import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../constants/layout/store/filterSlice";
import Select from "react-select";
import CustomDatePicker from "../../components/Custom-Datepicker";
import ProfileInput from "../../components/ProfilePic";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import CustomDatePickerIndex from "../../components/Custom-Datepicker-Type-Index-Module";
import FileUploader from "../../components/MultipleFileUploader";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../services/serviceCaller";
import { API_URL } from "../../constants";
import moment from "moment";
const TooltipWrapper = ({ value, tooltipText, children }) => {
  const hasValue = value !== null && value !== undefined && value !== "";
  return hasValue ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{tooltipText}</Tooltip>}
    >
      <div>{children}</div>
    </OverlayTrigger>
  ) : (
    <div>{children}</div>
  );
};
const EmployeeEdit = () => {
  const { id } = useParams();
  const initialFormData = {
    EmpCode: "",
    Title: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    TotalYearExp: "",
    TotalMonthExp: "",
    FatherName: "",
    FatherDOB: null,
    Email: "",
    AlternateEMail: "",
    MotherName: "",
    MotherDOB: null,
    IsInActive: "",
    UploadProfileImg: "",
    Gender_020: "",
    DateOfBirth: null,
    MobileNo1: "",
    MobileNo2: "",
    AccountID: "",
    IsRemotly: "",
    IsIntern: "",
    Location: "",
    ContactType_011: "",
    // Correpondence Address
    CorrepondenceAddressType: 823,
    PermanentAddressType: 822,
    CorrespondenceAddress: "",
    CorrespondenceState: "",
    CorrespondenceCountry: "",
    CorrespondenceZipCode: "",
    CorrespondenceAddressPrint: "",
    CorrespondenceCity: "",
    // Permanant Address
    permanentAddressCode: "",
    permanentAddressCountryID: "",
    permanentAddressStateID: "",
    permanentAddressCityID: "",
    permanentAddressZipCode: "",
    permanentPrintAddress: "",
    IsCopyAddress: 0,
    employeeAttachments: [],
    qualification: [
      // {
      //   QualificationType: "",
      //   Qualification: "",
      //   Stream: "",
      //   Institute: "",
      //   University: "",
      //   YearOfPassing: "",
      //   Percentage: "",
      //   LineNo: "1",
      // },
    ],
    identities: [
      {
        IdentityType_063: "",
        NameOnIdentity: "",
        IdentityNo: "",
        IssuingCountry: "",
        IssueDate: null,
        ExpiryDate: null,
        IdentityFile: "",
        LineNo: "1",
      },
    ],
    employeedocs: [
      // {
      //   IdentityType_063: "",
      //   IsComfirmedDocs:0,
      //   Remarks: "",
      //   LineNo: "1",
      // },
    ],
    empLocation: [
      {
        LineNo: "1",
        CityID: "",
        CityName: "",
        FromDate: null,
        ToDate: null,
      },
    ],
    files: [],
    filesize: [],
    GSTNo: "",
    VATNo: "",
    CSTNo: "",
    PANNo: "",
    GSTEffectiveDate: null,
    VATEffectiveDate: null,
    CSTEffectiveDate: null,
    STNo: "",
    WorkingStatus: "",
    STEffectiveDate: null,
    GSTRegistrationType_192: "",
    EmployeeCategory_057: "",
    LeaveAccrualType_155: null,
    ReferBy: null,
    ResignationDate: "",
    ConfirmationDate: "",
    RelivingDate: "",
    RelivingType_119: null,
    BandType_2015: null,
    SubBandType_2015: null,
    employeeDetails: [
      {
        LineNo: "1",
        ShiftID: "",
        DepartmentID: "",
        SubDepartmentID: "",
        DesignationID: "",
        FromDate: "",
        ToDate: "",
        ImmediateSuperiorID: "",
        PracticeManager: "",
        Branch: "",
      },
    ],
    employment_history: [
      {
        OrganizationName: "",
        Location: "",
        StartDate: "",
        EndDate: "",
        Position: "",
        OfferLetter: null,
        OfferLetterPreview: null,
        SalarySlip: null,
        SalarySlipPreview: null,
        RelievingLetter: null,
        RelievingLetterPreview: null,
      },
    ],
    workingarea: [
      // { LineNo: "1", EmployeeType_069: "", Company: "", Branch: "" },
    ],
    BloodGroup_062: null,
    MaritalStatus_021: null,
    DateOfAnniversary: "",
    AppointmentDate: null,
    JoiningDate: null,
    PayrollJoiningDate: null,
    OnPayroll: "",
    Apprenticeship: "",
    IsPartTime: "",
    Bond: "",
    Incentives: "",
    JoiningBonus:"",
    employeebank: [
      // {
      //   AccountNo: "",
      //   Bank: "",
      //   IFSCCode: "",
      //   Branch: "",
      //   DefaultBank: 0,
      //   LineNo: "1",
      // },
    ],
    DeskPhoneNo: "",
    EmergencyPhoneNo: "",
    EmergencyContactName: "",
    EmergencyContactRelation: "",
    PersonalEmail: "",
    OfficeEmail: "",
    PayTo: "",
    Nationality: null,
    BranchID: "",
    TotalYearExp: "",
    TotalMonthExp: "",
  };

  let tableSelectStyle = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const [formData, setFormData] = useState(initialFormData);
  const [cityIDOptions, setCityIDOptions] = useState("");
  console.log("formdata::formData",formData);
  

  // const staticId = 1364;

  useEffect(() => {
    fetchEmployeeDetails(id);
  }, []);

  const [joiningDateDisable, setJoiningDateDisable] = useState(false);
  const fetchEmployeeDetails = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/employee-data/${id}`
      );

      if (response.status === 200 && response?.data?.data?.contactDetails) {
        const fetchEmpConatctData = response?.data?.data?.contactDetails;
        const fetchEmpPendingData = response?.data?.data?.employeemissingDocs;
        console.log('fetchEmpPendingData',fetchEmpPendingData);
        
        const fetchEmpData = response?.data?.data?.employeeDetails;
        const fetchEmpAddressData = response?.data?.data?.employeeAddress;
        const fetchAttachment = response?.data?.data?.employeeAttachment;
        const fetchBankData = response?.data?.data?.employeeBank;
        const fetchLocationHistory = response?.data?.data?.employeeLocation;
        const fetchWorkingDetails =
          response?.data?.data?.employeeExecutivesDetails;
        const fetchQualificationDetails =
          response?.data?.data?.employeeQualification;
        const fetchEmpIdentitiesDetails =
          response?.data?.data?.employeeIdentities;
        const fetchEmpHistoryDetails = response?.data?.data?.EmployeeHistory;

        setJoiningDateDisable(fetchEmpData?.PayrollJoiningDate ? true : false);
        const empHistoryData = fetchEmpHistoryDetails
          ? Array.isArray(fetchEmpHistoryDetails)
            ? fetchEmpHistoryDetails.map((item, index) => ({
              ID: item.ID || "",
              Branch: item.BranchID || "",
              ShiftID: item.ShiftID || "",
              DepartmentID: item.DepartmentID || "",
              SubDepartmentID: item.SubDepartmentID || "",
              DesignationID: item.DesignationID || "",
              ImmediateSuperiorID: item.ImmediateSuperiorID || 0,
              PracticeManager: item.PracticeManager || 0,
              FromDate: item.FromDate
                ? moment(item.FromDate).format("DD-MMM-YYYY")
                : "",
              ToDate: item.ToDate
                ? moment(item.ToDate).format("DD-MMM-YYYY")
                : "",
              LineNo: item.LineNo || "1",
              canBeDisabled: 1,
              canBeTodateDisabled:
                index === fetchEmpHistoryDetails.length - 1 ? 0 : 1,
            }))
            : [
              {
                ID: fetchEmpHistoryDetails.ID || "",
                Branch: fetchEmpHistoryDetails.BranchID || "",
                ShiftID: fetchEmpHistoryDetails.ShiftID || "",
                DepartmentID: fetchEmpHistoryDetails.DepartmentID || "",
                SubDepartmentID: fetchEmpHistoryDetails.SubDepartmentID || "",
                DesignationID: fetchEmpHistoryDetails.DesignationID || "",
                ImmediateSuperiorID:
                  fetchEmpHistoryDetails.ImmediateSuperiorID || 0,
                PracticeManager: fetchEmpHistoryDetails.PracticeManager || 0,
                FromDate: fetchEmpHistoryDetails.FromDate
                  ? moment(fetchEmpHistoryDetails.FromDate).format(
                    "DD-MMM-YYYY"
                  )
                  : "",
                // ToDate: fetchEmpHistoryDetails.ToDate || "",
                ToDate: fetchEmpHistoryDetails.ToDate
                  ? moment(fetchEmpHistoryDetails.ToDate).format(
                    "DD-MMM-YYYY"
                  )
                  : "",
                LineNo: fetchEmpHistoryDetails.LineNo || "1",
              },
            ]
          : [];

        const EmployeeMissingDocData = fetchEmpPendingData
          ? Array.isArray(fetchEmpPendingData)
            ? fetchEmpPendingData.map((item) => ({
              ID: item.ID || "",
              IdentityType_063: item.IdentityType_063 || "",
              IsComfirmedDocs: item.IsComfirmedDocs || 0,
              Remarks: item.Remarks || "",
              LineNo: item.LineNo || "1",
              TargetDate: item.TargetDate || null,
              canBeDisabled: item.IsComfirmedDocs === 1 ? 1 : 0, 
            }))
            : [
              {
                ID: fetchEmpPendingData.ID || "",
                IdentityType_063:
                  fetchEmpPendingData.IdentityType_063 || "",
                IsComfirmedDocs: fetchEmpPendingData.IsComfirmedDocs || 0,
                Remarks:
                  fetchEmpPendingData.Remarks || "",
                LineNo: fetchEmpPendingData.LineNo || "1",
                TargetDate: fetchEmpPendingData.TargetDate || null,
                canBeDisabled: fetchEmpPendingData.IsComfirmedDocs === 1 ? 1 : 0,
              },
            ]
          : [];
          console.log("Employee Missing Data",EmployeeMissingDocData);
          

        const identitiesData = fetchEmpIdentitiesDetails
          ? Array.isArray(fetchEmpIdentitiesDetails)
            ? fetchEmpIdentitiesDetails.map((item) => ({
              ID: item.ID || "",
              IdentityType_063: item.IdentityType_063 || "",
              NameOnIdentity: item.NameOnIdentity || "",
              IdentityNo: item.IdentityNo || "",
              IssuingCountry: item.IssuingCountry || "",
              IssueDate: item.IssueDate
                ? moment(item.IssueDate).format("DD-MMM-YYYY")
                : "",
              ExpiryDate: item.ExpiryDate
                ? moment(item.ExpiryDate).format("DD-MMM-YYYY")
                : "",
              IdentityFile: item.IdentityFile || item.FileName || item.FilePath || "",
              LineNo: item.LineNo || "1",
            }))
            : [
              {
                ID: fetchEmpIdentitiesDetails.ID || "",
                IdentityType_063:
                  fetchEmpIdentitiesDetails.IdentityType_063 || "",
                NameOnIdentity:
                  fetchEmpIdentitiesDetails.NameOnIdentity || "",
                IdentityNo: fetchEmpIdentitiesDetails.IdentityNo || "",
                LineNo: fetchEmpIdentitiesDetails.LineNo || "1",
                IssuingCountry:
                  fetchEmpIdentitiesDetails.IssuingCountry || "",
                IssueDate: fetchEmpIdentitiesDetails.IssueDate
                  ? moment(fetchEmpIdentitiesDetails.IssueDate).format(
                    "DD-MMM-YYYY"
                  )
                  : "",

                ExpiryDate: fetchEmpIdentitiesDetails.ExpiryDate
                  ? moment(fetchEmpIdentitiesDetails.ExpiryDate).format(
                    "DD-MMM-YYYY"
                  )
                  : "",
                IdentityFile: fetchEmpIdentitiesDetails.IdentityFile || fetchEmpIdentitiesDetails.FileName || fetchEmpIdentitiesDetails.FilePath || "",
              },
            ]
          : [];

        // Location History data set
        const locationHistoryData = fetchLocationHistory
          ? Array.isArray(fetchLocationHistory)
            ? fetchLocationHistory.map((item) => ({
              ID: item.ID || "",
              CityID: item.CityID || "",
              CityName: item.CityName || "",
              FromDate: item.FromDate
                ? moment(item.FromDate).format("DD-MMM-YYYY")
                : "",
              ToDate: item.ToDate
                ? moment(item.ToDate).format("DD-MMM-YYYY")
                : "",
              LineNo: item.LineNo || "1",
            }))
            : [
              {
                ID: fetchLocationHistory.EmployeeID || "",
                CityID: fetchLocationHistory.CityID || "",
                CityName: fetchLocationHistory.CityName || "",
                FromDate: fetchLocationHistory.FromDate
                  ? moment(fetchLocationHistory.FromDate).format(
                    "DD-MMM-YYYY"
                  )
                  : "",
                ToDate: fetchLocationHistory.ToDate
                  ? moment(fetchLocationHistory.ToDate).format("DD-MMM-YYYY")
                  : "",
              },
            ]
          : [];

        const eduData = fetchQualificationDetails
          ? Array.isArray(fetchQualificationDetails)
            ? fetchQualificationDetails.map((item) => ({
              ID: item.ID || "",
              QualificationType: item.QualificationType || "",
              Qualification: item.Qualification || "",
              Stream: item.Stream || "",
              Institute: item.Institute || "",
              Percentage: item.Percentage || "",
              YearOfPassing: item.YearOfPassing || "",
              University: item.University || "",
              QualificationFile: item.QualificationFile || item.FilePath || item.FileName || "",
              LineNo: item.LineNo || "1",
            }))
            : [
              {
                ID: fetchQualificationDetails.ID || "",
                QualificationType:
                  fetchQualificationDetails.QualificationType || "",
                Qualification: fetchQualificationDetails.Qualification || "",
                Stream: fetchQualificationDetails.Stream || "",
                Institute: fetchQualificationDetails.Institute || "",
                Percentage: fetchQualificationDetails.Percentage || "",
                YearOfPassing: fetchQualificationDetails.YearOfPassing || "",
                University: fetchQualificationDetails.University || "",
                QualificationFile: fetchQualificationDetails.QualificationFile || fetchQualificationDetails.FilePath || fetchQualificationDetails.FileName || "",
                LineNo: fetchQualificationDetails.LineNo || "1",
              },
            ]
          : [];

        const workingData = fetchWorkingDetails
          ? Array.isArray(fetchWorkingDetails)
            ? fetchWorkingDetails.map((item) => ({
              ID: item.ID || "",
              Company: item.CompanyID || "",
              Branch: item.BranchID || "",
              EmployeeType_069: item.EmployeeType_069 || "",
              LineNo: item.LineNo || "1",
            }))
            : [
              {
                ID: fetchWorkingDetails.ID || "",
                Company: fetchWorkingDetails.CompanyID || "",
                Branch: fetchWorkingDetails.BranchID || "",
                EmployeeType_069: fetchWorkingDetails.EmployeeType_069 || "",
                LineNo: fetchWorkingDetails.LineNo || "1",
              },
            ]
          : [];

        const bankData = fetchBankData
          ? Array.isArray(fetchBankData)
            ? fetchBankData.map((item) => ({
              ID: item.ID || "",
              IFSCCode: item.IFSCCode || "",
              AccountNo: item.AccountNo || "",
              Branch: item.Branch || "",
              Bank: item.Bank || "",
              DefaultBank: item.DefaultBank || 0,
              LineNo: item.LineNo || "1",
              PayTo: item.PayTo || "",
            }))
            : [
              {
                ID: fetchBankData.ID || "",
                IFSCCode: fetchBankData.IFSCCode || "",
                AccountNo: fetchBankData.AccountNo || "",
                Branch: fetchBankData.Branch || "",
                Bank: fetchEmpData.Bank || "",
                DefaultBank: fetchBankData.DefaultBank || 0,
                LineNo: fetchBankData.LineNo || "1",
                PayTo: fetchEmpConatctData.PayTo || "",
              },
            ]
          : [];

        // Ensure values are not undefined
        const formDataEdit = {
          ...initialFormData,

          // files: fetchAttachment
          //   ? fetchAttachment.map((file) => ({
          //       name: file.FileName
          //         ? file.FileName.split("/")
          //             .pop()
          //             .split("_")
          //             .slice(-2)
          //             .join("_") // Extract required part of filename
          //         : "",

          files: fetchAttachment
            ? fetchAttachment.map((file) => ({
              name: file.FileName
                ? file.FileName.split("employee_attachments/").pop()
                : "",

              size: file.FileSize
                ? (file.FileSize / 1024 / 1024).toFixed(2) + " MB"
                : "0 MB", // Convert file size to MB format
              filePath: file.FileName,
              FileData: file.FileData,
            }))
            : [],
          filesize: fetchAttachment
            ? fetchAttachment.map((file) =>
              file.FileSize
                ? (file.FileSize / 1024 / 1024).toFixed(2) + " MB"
                : "0 MB"
            )
            : [],
          EmpCode: fetchEmpConatctData.Code,
          Title: fetchEmpConatctData.Salutation_019,
          FirstName: fetchEmpConatctData.FirstName,
          MiddleName: fetchEmpConatctData.MiddleName,
          LastName: fetchEmpConatctData.LastName,
          FatherName: fetchEmpData.FatherName,
          SpouseName: fetchEmpConatctData.SpouseName,
          Child1Name: fetchEmpConatctData.Child1Name,
          Child2Name: fetchEmpConatctData.Child2Name,
          UploadProfileImg: fetchEmpData.ProfileImage,
          FatherDOB: fetchEmpData?.FatherDOB
            ? moment(fetchEmpData.FatherDOB).format("DD-MMM-YYYY")
            : null,
          MotherName: fetchEmpData.MotherName,
          MotherDOB: fetchEmpData?.MotherDOB
            ? moment(fetchEmpData.MotherDOB).format("DD-MMM-YYYY")
            : null,
          ContactType_011: Number(fetchEmpConatctData.ContactType_011),
          IsInActive: fetchEmpData?.IsInActive,
          AccountType: fetchEmpConatctData.AccountID,
          Gender_020: fetchEmpConatctData.Gender_020,
          TotalYearExp: fetchEmpData?.TotalYearExp,
          TotalMonthExp: fetchEmpData?.TotalMonthExp,
          PFNomineeName: fetchEmpData?.PFNomineeName || "",
          PFNomineeRelation: fetchEmpData?.PFNomineeRelation || "",
          DateOfBirth: fetchEmpConatctData?.DateOfBirth
            ? moment(fetchEmpConatctData.DateOfBirth).format("DD-MMM-YYYY")
            : "",
          MobileNo1: fetchEmpConatctData?.MobileNo1
            ? fetchEmpConatctData.MobileNo1.replace(/\D/g, "").slice(-10)
            : "",
          MobileNo2: fetchEmpConatctData?.MobileNo2
            ? fetchEmpConatctData.MobileNo2.replace(/\D/g, "").slice(-10)
            : "",
          DeskPhoneNo: fetchEmpAddressData[0]?.PhoneNo1
            ? fetchEmpAddressData[0].PhoneNo1.replace(/\D/g, "").slice(-10)
            : "",
          EmergencyPhoneNo: fetchEmpData?.EmergencyPhoneNo
            ? fetchEmpData.EmergencyPhoneNo.replace(/\D/g, "").slice(-10)
            : fetchEmpConatctData.PhoneNo2,
          EmergencyContactName: fetchEmpData?.EmergencyContactName,
          EmergencyContactRelation: fetchEmpData?.EmergencyContactRelation,
          OfficeEmail: fetchEmpConatctData?.Email,
          PersonalEmail: fetchEmpConatctData?.AlternateEMail,
          Location: fetchEmpAddressData[0]?.Location,
          IsIntern: fetchEmpConatctData?.IsIntern ? "1" : "0",
          IsPartTime: fetchEmpData?.IsPartTime ? "1" : "0",
          OnPayroll: fetchEmpData?.OnPayroll ? "1" : "0",
          Apprenticeship: fetchEmpData?.Apprenticeship ? "1" : "0",
          Bond:fetchEmpData?.Bond ? "1" : "0",
          Incentives:fetchEmpData?.Incentives ? "1" : "0",
          JoiningBonus:fetchEmpData?.JoiningBonus ? "1" : "0",
          // Correspondence Address
          CorrespondenceAddress: fetchEmpAddressData[0]?.AddressLine2,
          CorrespondenceCountryID: fetchEmpAddressData[0]?.CountryID,
          CorrespondenceCountry: fetchEmpAddressData[0]?.CountryID,
          CorrespondenceState: fetchEmpAddressData[0]?.StateID,
          CorrespondenceStateID: fetchEmpAddressData[0]?.StateID,
          CorrespondenceCity: fetchEmpAddressData[0]?.CityID,
          CorrespondenceCityID: fetchEmpAddressData[0]?.CityID,
          CorrespondenceZipCode: fetchEmpAddressData[0]?.ZipCode,
          CorrespondenceAddressPrint: fetchEmpAddressData[0]?.PrintAddress,
          // Permanent Address
          permanentAddressCode: fetchEmpAddressData[1]?.AddressLine2,
          permanentAddressCountryID: fetchEmpAddressData[1]?.CountryID,
          permanentAddressStateID: fetchEmpAddressData[1]?.StateID,
          permanentAddressCityID: fetchEmpAddressData[1]?.CityID,
          permanentAddressZipCode: fetchEmpAddressData[1]?.ZipCode,
          permanentPrintAddress: fetchEmpAddressData[1]?.PrintAddress,
          GSTNo: fetchEmpAddressData?.GSTNo,
          VATNo: fetchEmpAddressData?.VATNo,
          CSTNo: fetchEmpAddressData?.CSTNo,
          PANNo: fetchEmpAddressData?.PANNo,
          GSTEffectiveDate: fetchEmpAddressData?.GSTEffectiveDate
            ? moment(fetchEmpAddressData.GSTEffectiveDate).format("DD-MMM-YYYY")
            : "",
          VATEffectiveDate: fetchEmpAddressData?.VATEffectiveDate
            ? moment(fetchEmpAddressData.VATEffectiveDate).format("DD-MMM-YYYY")
            : "",
          CSTEffectiveDate: fetchEmpAddressData?.CSTEffectiveDate
            ? moment(fetchEmpAddressData.CSTEffectiveDate).format("DD-MMM-YYYY")
            : "",
          SpouseDOB:fetchEmpConatctData?.SpouseDOB
            ? moment(fetchEmpConatctData.SpouseDOB).format("DD-MMM-YYYY")
            : "",
          Child1DOB:fetchEmpConatctData?.Child1DOB
            ? moment(fetchEmpConatctData.Child1DOB).format("DD-MMM-YYYY")
            : "",
          Child2DOB:fetchEmpConatctData?.Child2DOB
            ? moment(fetchEmpConatctData.Child2DOB).format("DD-MMM-YYYY")
            : "",
          STNo: fetchEmpAddressData?.STNo,
          GSTRegistrationType_192: fetchEmpAddressData?.GSTRegistrationType_192,
          STEffectiveDate: fetchEmpAddressData?.STEffectiveDate
            ? moment(fetchEmpAddressData.STEffectiveDate).format("DD-MMM-YYYY")
            : "",
          LeaveAccrualType_155: fetchEmpData?.LeaveAccrualType_155,
          WorkingStatus: fetchEmpData?.EmployeeCategory_057,
          RelivingType_119: fetchEmpData?.RelivingType_119,
          BandType_2015: fetchEmpData?.BandType_2015,
          SubBandType_2015: fetchEmpData?.SubBandType_2015,
          ResignationDate: fetchEmpData?.ResignationDate
            ? moment(fetchEmpData.ResignationDate).format("DD-MMM-YYYY")
            : "",
          ReferBy: fetchEmpData?.ReferBy,
          ConfirmationDate: fetchEmpData?.ConfirmationDate
            ? moment(fetchEmpData.ConfirmationDate).format("DD-MMM-YYYY")
            : "",
          RelivingDate: fetchEmpData?.RelivingDate
            ? moment(fetchEmpData.RelivingDate).format("DD-MMM-YYYY")
            : "",
          BloodGroup_062: fetchEmpData?.BloodGroup_062,
          MaritalStatus_021: fetchEmpConatctData?.MaritalStatus_021,
          Nationality: fetchEmpData?.Nationality_061 || null,
          BranchID: fetchEmpConatctData?.BranchID,
          DateOfAnniversary: fetchEmpConatctData?.DateOfAnniversary
            ? moment(fetchEmpConatctData.DateOfAnniversary).format(
              "DD-MMM-YYYY"
            )
            : "",
          AppointmentDate: fetchEmpData?.AppointmentDate
            ? moment(fetchEmpData.AppointmentDate).format("DD-MMM-YYYY")
            : "",
          JoiningDate: fetchEmpData?.JoiningDate
            ? moment(fetchEmpData.JoiningDate).format("DD-MMM-YYYY")
            : "",

          PayrollJoiningDate: fetchEmpData?.PayrollJoiningDate
            ? moment(fetchEmpData.PayrollJoiningDate).format("DD-MMM-YYYY")
            : "",
          employeebank:
            bankData.length > 0 ? bankData : initialFormData.employeebank,
          workingarea:
            workingData.length > 0 ? workingData : initialFormData.workingarea,

          qualification:
            eduData.length > 0 ? eduData : initialFormData.qualification,
          employeedocs: EmployeeMissingDocData.length > 0 ? EmployeeMissingDocData : initialFormData.employeedocs,
          identities:
            identitiesData.length > 0
              ? identitiesData
              : initialFormData.identities,
          employeeDetails:
            empHistoryData.length > 0
              ? empHistoryData
              : initialFormData.employeeDetails,
          empLocation: locationHistoryData.length > 0 ? locationHistoryData : initialFormData.empLocation,
          employment_history: response?.data?.data?.employment_history || response?.data?.data?.employmentHistory || initialFormData.employment_history,
        };
        const corrAddress = fetchEmpAddressData?.[0] || {};
        const permAddress = fetchEmpAddressData?.[1] || {};

        const isSameAddress =
          corrAddress.AddressCode == permAddress.AddressCode &&
          corrAddress.CityID == permAddress.CityID &&
          corrAddress.ZipCode == permAddress.ZipCode &&
          corrAddress.PrintAddress == permAddress.PrintAddress;

        setFormData(formDataEdit);
        const updatedData = isSameAddress ? 1 : 0;
        setFormData((prev) => ({
          ...prev,
          IsCopyAddress: isSameAddress ? 1 : 0,
        }));
      } else {
        console.error(
          "Failed to fetch employee data. Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Employee"));
  }, []);

  const handleProfilePic = (image) => {
    setFormData((prevData) => ({
      ...prevData,
      UploadProfileImg: image,
    }));
  };

  // const handleFile = (files) => {
  //   if (!files || files.length === 0) {
  //     alert("Please select a valid file under 5MB.");
  //     return;
  //   }

  //   const fileNames = Array.from(files).map((file) => file.name);
  //   const fileSizes = Array.from(files).map(
  //     (file) => (file.size / 1024 / 1024).toFixed(2) + " MB"
  //   );

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     files: [...prevData.files, ...fileNames],
  //     filesize: [...prevData.filesize, ...fileSizes],
  //   }));
  // };

  const handleFile = (files) => {
    if (!files || files.length === 0) {
      alert("Please select a valid file under 5MB.");
      return;
    }

    const fileList = Array.from(files).filter(
      (file) => file.size <= 5 * 1024 * 1024
    ); // Filter files under 5MB

    if (fileList.length === 0) {
      alert("All selected files exceed 5MB.");
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      files: [...prevData.files, ...fileList], // Store full file objects
      filesize: [
        ...prevData.filesize,
        ...fileList.map((file) => (file.size / 1024 / 1024).toFixed(2) + " MB"),
      ],
    }));
  };
  const removeFile = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      employeeAttachments: prevData.employeeAttachments.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const schema = Yup.object().shape({
    Title: Yup.number()
      .typeError("Title is required")
      .required("Title is required"),
    BranchID: Yup.number()
      .typeError("Branch is required")
      .required("Branch is required"),
    FirstName: Yup.string().required("First Name is required"),
    MiddleName: Yup.string().nullable(),
    LastName: Yup.string().required("Last Name is required"),
    FatherName: Yup.string().nullable(),
    TotalYearExp: Yup.string().required("Total Year Exp is required"),
    TotalMonthExp: Yup.string().required("Total Month Exp is required"),
    FatherDOB: Yup.string().nullable(),
    MotherName: Yup.string().nullable(),
    MotherDOB: Yup.string().nullable(),
    IsInActive: Yup.string().nullable(),
    UploadProfileImg: Yup.mixed().required("Profile picture is required."),
    ContactType_011: Yup.number()
      .typeError("Contact Type is required")
      .required("Contact Type is required"),
    AccountType: Yup.number()
      .typeError("Account Type is required")
      .required("Account Type is required"),
    Gender_020: Yup.number()
      .typeError("Gender is required")
      .required("Gender is required"),
    DateOfBirth: Yup.string().required("Date of Birth is required"),
    MobileNo1: Yup.string()
      .required("Mobile No is required")
      .matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    MobileNo2: Yup.string()
      .nullable()
      .matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    DeskPhoneNo: Yup.string().nullable(),
    EmergencyPhoneNo: Yup.string().required("Emergency PhoneNo is required").matches(/^\d{10}$/, "Mobile No must be exactly 10 digits"),
    EmergencyContactName: Yup.string().required(
      "Emergency Contact Name is Required"
    ),
    EmergencyContactRelation: Yup.string().required(
      "Contact Relation In Required"
    ),
    PersonalEmail: Yup.string().required("Personal Email is Required"),
    OfficeEmail: Yup.string().required("NSS Email is Required"),
    Location: Yup.string().required("Joining Location Required"),
    WorkingRemote: Yup.string().nullable(),
    CorrepondenceAddressType: Yup.mixed().nullable(),
    CorrespondenceAddress: Yup.string().required("Address is Required"),
    CorrespondenceCountry: Yup.number()
      .typeError("Country is required")
      .required("Country is required"),
    CorrespondenceState: Yup.number()
      .typeError("State is required")
      .required("State is required"),
    CorrespondenceCity: Yup.number()
      .typeError("City is required")
      .required("City is required"),
    CorrespondenceZipCode: Yup.string().nullable(),
    CorrespondenceAddressPrint: Yup.string(),
    permanentAddressCode: Yup.string(),
    permanentAddressCityID: Yup.string(),
    permanentAddressStateID: Yup.string(),
    permanentAddressCountryID: Yup.string(),
    permanentAddressZipCode: Yup.string().nullable(),
    employeebank: Yup.array()
      .of(
        Yup.object().shape({
          AccountNo: Yup.string()
            .matches(/^\d{9,18}$/, "Account No must be between 9-18 digits")
            .required("Account No is required"),
          // Branch: Yup.string().required("Bank Branch is required"),
          Bank: Yup.string().required("Please select Bank"),
          IFSCCode: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code format")
            .required("IFSC Code is required"),
          DefaultBank: Yup.number() // Changed from string to number
            .oneOf([0, 1], "Invalid Default Bank value")
            .test(
              "at-least-one-default",
              "At least one bank must be set as default",
              function (value, context) {
                // Check if at least one item in the array has DefaultBank === 1
                if (context.parent.DefaultBank === 1) return true; // Current item is default

                // Check other items in the array
                const parentArray = context.from[1].value.employeebank || [];
                return parentArray.some((item) => item.DefaultBank === 1);
              }
            ),
        })
      )
      .min(1, "At least one bank detail is required"),

    GSTNo: Yup.string().nullable(),
    VATNo: Yup.string().nullable(),
    CSTNo: Yup.string().nullable(),
    PANNo: Yup.string().nullable(),
    GSTEffectiveDate: Yup.string().nullable(),
    VATEffectiveDate: Yup.string().nullable(),
    CSTEffectiveDate: Yup.string().nullable(),
    STNo: Yup.string().nullable(),
    GSTRegistrationType_192: Yup.mixed().nullable(),
    STEffectiveDate: Yup.string().nullable(),
    WorkingStatus: Yup.mixed().nullable(),
    LeaveAccrualType_155: Yup.number()
      .nullable()
      .test(
        "is-mandatory",
        "Leave Accrual Type is required",
        function (value) {
          const { employeeDetails } = this.parent;
          if (employeeDetails && employeeDetails.length > 0) {
            const isActiveIntern = employeeDetails.some(
              (detail) =>
                String(detail.DesignationID) === "178" &&
                (!detail.ToDate || detail.ToDate === "")
            );
            if (isActiveIntern) {
              return true;
            }
          }
          return value !== null && value !== undefined && value !== "";
        }
      ),
    ReferBy: Yup.number().nullable(),
    ResignationDate: Yup.string().nullable(),
    ConfirmationDate: Yup.string().nullable(),
    RelivingDate: Yup.string().nullable(),
    RelivingType_119: Yup.number().nullable(),
    BandType_2015: Yup.number().required("Brand Type is required"),
    SubBandType_2015: Yup.number().required("SubBrand Type is required"),

    employeeDetails: Yup.array().of(
      Yup.object().shape({
        ShiftID: Yup.string().required("Shift is required"),
        Branch: Yup.string().required("Branch is required"),
        DepartmentID: Yup.string().required("Department is required"),
        // SubDepartmentID: Yup.string().nullable(),
        DesignationID: Yup.string().required("Designation is required"),
        ImmediateSuperiorID: Yup.string()
          .required("Immediate Superior is required")
          .nullable(),
        PracticeManager: Yup.string()
          .required("Practice Manager is required")
          .nullable(),
        FromDate: Yup.string().required("From Date is required"),
        ToDate: Yup.string().nullable(),
      })
    ),
    // Enhanced validation for employeedocs
    employeedocs: Yup.array()
      .of(
        Yup.object().shape({
          IdentityType_063: Yup.string()
            .required("Misssing Docs: Document Type is required")
            .test('not-empty', 'Document Type is required', value => {
              return value !== null && value !== undefined && value !== '';
            }),
          Remarks: Yup.string()
            .required("Misssing Docs: Remarks is required"), // No validation for Remarks
          TargetDate: Yup.string() // Add this validation
            .required("Misssing Docs: Target Date is required"),
          IsComfirmedDocs: Yup.number()
            .oneOf([0, 1], "Invalid value")
            .default(0)
        })
      )
      .optional(),
    // workingarea: Yup.array()
    //   .of(
    //     Yup.object().shape({
    //       EmployeeType_069: Yup.string().required("Employee Type is required"),
    //       Branch: Yup.string().required("Branch Is Required"),
    //     })
    //   )
    //   .min(1, "At least one Working Area is required"),

    employeeAttachments: Yup.mixed().nullable(),

    qualification: Yup.array()
      .of(
        Yup.object().shape({
          QualificationType: Yup.string().required(
            "Qualification Type is required"
          ),
          Qualification: Yup.string().nullable(),
        })
      )
      .when("qualifications", {
        is: (value) => value && value.length > 0, // if array is not empty
        then: Yup.array().min(1, "At least one qualification is required"),
      }),

    identities: Yup.array()
      .of(
        Yup.object().shape({
          IdentityType_063: Yup.string().required("Identity Type is required"),
          NameOnIdentity: Yup.string().required(
            "Name On Indentity Is Required"
          ),
          IdentityNo: Yup.string().required("Indentity No Is Required"),
          IssuingCountry: Yup.string().required(
            "Indentity Issuing Country Is Required"
          ),
          IssueDate: Yup.string().nullable(),
        })
      )
      .min(1, "At least one identity is required"),

    BloodGroup_062: Yup.number()
      .typeError("Blood Group is required")
      .required("Blood Group is required"),
    PFNomineeName: Yup.string().required("PF Nominee Name is required"),
    PFNomineeRelation: Yup.string().required("PF Nominee Relation is required"),
    MaritalStatus_021: Yup.mixed().nullable(),
    Nationality: Yup.mixed().nullable(),
    DateOfAnniversary: Yup.string().nullable(),
    AppointmentDate: Yup.string().required("Appointment Date is Required"),
    JoiningDate: Yup.string().required("Joining Date is Required"),
    PayrollJoiningDate: Yup.string().required(
      "Payroll Joining Date is Required"
    ),
    // Branch: Yup.number()
    //   .typeError("Branch is required")
    //   .required("Branch is required"),
    OnPayroll: Yup.string().nullable().nullable(),
    Apprenticeship: Yup.string().nullable().nullable(),
    Bond: Yup.string().nullable().nullable(),
    Incentives:Yup.string().nullable().nullable(),
    JoiningBonus:Yup.string().nullable().nullable(),
    IsIntern: Yup.string().nullable().nullable(),
    Partime: Yup.string().nullable().nullable(),
  });

  // Validate individual field
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));

      if (fieldName.startsWith("lines")) {
        toast.error(err.message, { position: "top-right" });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmit(true);

    try {
      // Skip validation if FirstName contains "sub_contractor" (case insensitive)
      const shouldSkipValidation =
        formData?.FirstName?.toLowerCase().includes("sub_contractor");
      if (!shouldSkipValidation) {

        await schema.validate(formData, { abortEarly: false });
        setErrors({}); // Clear errors if validation passes
      }

      let formattedFormData = {};

      if (shouldSkipValidation) {
        formattedFormData = {
          ...formData,
          identities: formData?.identities?.every((item) => !item?.IdentityNo)
            ? []
            : formData?.identities,
        };
      } else {
        formattedFormData = {
          ...formData,
          DateOfAnniversary: formData.DateOfAnniversary
            ? moment(formData.DateOfAnniversary).format("YYYY-MM-DD")
            : null,
          SpouseDOB: formData.SpouseDOB
            ? moment(formData.SpouseDOB).format("YYYY-MM-DD")
            : null,
          Child1DOB: formData.Child1DOB
            ? moment(formData.Child1DOB).format("YYYY-MM-DD")
            : null,
          Child2DOB: formData.Child2DOB
            ? moment(formData.Child2DOB).format("YYYY-MM-DD")
            : null,
        };
      }


      // API call using Axios
      const response = await PostFormServiceCaller(
        `${API_URL}rujul/employee-data/${id}`,
        formattedFormData,
        "put"
      );

      // Handle success response
      if (response.status === 200) {
        setSubmit(false);
        toast.success("Form updated successfully!");
        setTimeout(() => {
          navigate("/employee-list");
        }, 2000);
      }
    } catch (error) {
      setSubmit(false);

      // Handle validation errors
      if (error.name === "ValidationError" && error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);

        // Show first error in toast
        if (error.inner.length > 0) {
          toast.error(error.inner[0].message);
        }
      }
      // Handle API errors
      else {
        console.error("API Error:", error);
        const errorMessage =
          error.response?.data?.message || "Failed to submit the form";
        toast.error(errorMessage);
      }
    }
  };
    useEffect(() => {
    if (formData?.BandType_2015) {
      fetchSubBrand(formData.BandType_2015);
    }
  }, [formData?.BandType_2015]);

  const fetchSubBrand = async (brandId) => {
    try {
      setSubBrandTypeOptions([]);

      const res = await GetServiceCaller(`${API_URL}rujul/band-designation-tracking-data/${brandId}`);
      const data = res.data.data;

      const formattedOptions = data.map((item) => ({
        value: String(item.ID),   // ✅ force string
        label: item.SubDetailName,
      }));
      console.log("formData SubBrand:", formData?.SubBandType_2015);
      console.log("options:", subrandTypeOptions);

      setSubBrandTypeOptions(formattedOptions);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSelect = async (selectedOption, name, e) => {
    const value = selectedOption.value;
    setFormData((prevState) => {
      let updatedData = { ...prevState, [name]: value }; // Update selected value

      // Handle country selection for both Correspondence and Permanent Address
      if (
        name === "CorrespondenceCountry" ||
        name === "permanentAddressCountryID"
      ) {
        updatedData = {
          ...updatedData,
          CorrespondenceState:
            name === "CorrespondenceCountry"
              ? null
              : prevState.CorrespondenceState,
          CorrespondenceCity:
            name === "CorrespondenceCountry"
              ? null
              : prevState.CorrespondenceCity,
          permanentAddressStateID:
            name === "permanentAddressCountryID"
              ? null
              : prevState.permanentAddressStateID,
          permanentAddressCityID:
            name === "permanentAddressCountryID"
              ? null
              : prevState.permanentAddressCityID,
        };
      }
      // Handle state selection for both Correspondence and Permanent Address
      else if (
        name === "CorrespondenceState" ||
        name === "permanentAddressStateID"
      ) {
        updatedData = {
          ...updatedData,
          CorrespondenceCity:
            name === "CorrespondenceState"
              ? null
              : prevState.CorrespondenceCity,
          permanentAddressCityID:
            name === "permanentAddressStateID"
              ? null
              : prevState.permanentAddressCityID,
        };
      }
      if (name === "BandType_2015") {
        updatedData.SubBandType_2015 = null;
        setSubBrandTypeOptions([]);
      }

      // Update CorrespondenceAddressPrint with labels instead of values
      updatedData.CorrespondenceAddressPrint = [
        updatedData.CorrespondenceAddress,
        cityOptions.find(
          (option) => option.value === updatedData.CorrespondenceCity
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.CorrespondenceState
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.CorrespondenceCountry
        )?.label,
        updatedData.CorrespondenceZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      // Update Permanent Address Print
      updatedData.permanentPrintAddress = [
        updatedData.permanentAddressCode, // Ensure this is correct
        cityOptions.find(
          (option) => option.value === updatedData.permanentAddressCityID
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.permanentAddressStateID
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.permanentAddressCountryID
        )?.label,
        updatedData.permanentAddressZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      validateField(name, updatedData);
      return updatedData;
    });

    // Fetch states or cities based on selection
    if (
      name === "CorrespondenceCountry" ||
      name === "permanentAddressCountryID"
    ) {
      await fetchState(value);
    } else if (
      name === "CorrespondenceState" ||
      name === "permanentAddressStateID"
    ) {
      await fetchCity(value);
    }
if (name === "SubBandType_2015") {
  setFormData((prev) => ({
    ...prev,
    SubBandType_2015: selectedOption?.value || "",
  }));
}

    // Clear errors for valid selection
    setErrors((errors) => ({
      ...errors,
      [name]: "",
    }));
  };

   const handleIdentityFileChange = (files, index) => { 

    if (!files || files.length === 0) return;

    const file = files[0];

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    
    setFormData((prev) => {
      const identities = [...prev.identities];

      identities[index] = {
        ...identities[index],
        IdentityFile: file,
        IdentityFilePreview: URL.createObjectURL(file),
      };

      return {
        ...prev,
        identities,
      };
    });
  };

  const handleChange = async (e) => {
    const { name, value, type } = e.target;

    setFormData((prevData) => {
      const updatedValue = type === "radio" ? Number(value) : value; // Convert radio values to number
      const updatedData = { ...prevData, [name]: updatedValue };

      // Update address labels (your existing logic)
      updatedData.CorrespondenceAddressPrint = [
        updatedData.CorrespondenceAddress,
        cityOptions.find(
          (option) => option.value === updatedData.CorrespondenceCity
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.CorrespondenceState
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.CorrespondenceCountry
        )?.label,
        updatedData.CorrespondenceZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      updatedData.permanentPrintAddress = [
        updatedData.permanentAddressCode,
        cityOptions.find(
          (option) => option.value === updatedData.permanentAddressCityID
        )?.label,
        stateOptions.find(
          (option) => option.value === updatedData.permanentAddressStateID
        )?.label,
        countryOptions.find(
          (option) => option.value === updatedData.permanentAddressCountryID
        )?.label,
        updatedData.permanentAddressZipCode,
      ]
        .filter(Boolean)
        .join(", ");

      validateField(name, updatedData);
      return updatedData;
    });
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? "1" : "0",
    }));
  };

  const fetchState = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];
        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setStateOptions(options);
      } else {
        console.error(
          "Failed to fetch states. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchCity = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];
        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCityOptions(options);
      } else {
        console.error(
          "Failed to fetch cities. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setPageLoading(false);
    }
  };
 
  const handleAllLineChange = async (e, index, section) => {
    const { name, type, checked, value } = e.target;
    const updatedSection = [...formData[section]]; // Copy the section array
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    if (section === "employeeDetails") {
      if (name === "ToDate" && updatedSection[index + 1]) {
        // Clear error for current ToDate
        setErrors((prevErrors) => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            [index]: {
              ...prevErrors[section]?.[index],
              ToDate: "",
            },
          },
        }));

        // Set next row's FromDate = current ToDate + 1 day
        updatedSection[index + 1]["FromDate"] = moment(newValue)
          .add(1, "days")
          .format("DD-MMM-YYYY");
      }
    }


    if (name === "DefaultBank" && newValue === 1) {
      const alreadySelected = updatedSection.find(
        (item, idx) => item.DefaultBank === 1 && idx !== index
      );
      if (alreadySelected) {
        toast.error("Only one Default Bank can be selected.");
        return; // Block further execution
      }
    }
    updatedSection[index][name] = newValue; // Update field value

    try {
      // Validate specific field dynamically from schema
      await schema.validateAt(`${section}[${index}].${name}`, {
        [section]: updatedSection,
      });

      // Update form state and clear errors if valid
      setFormData((prevState) => ({
        ...prevState,
        [section]: updatedSection,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: "" },
        },
      }));
    } catch (err) {
      // Set validation error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: err.message },
        },
      }));
    }
  };

  const handleLineSelect = async (selectedOption, name, index, section) => {
    const updatedSection = [...formData[section]];
    updatedSection[index][name] = selectedOption.value;
    // Update both CityID and CityName when CityID is selected
    if (name === "CityID") {
      updatedSection[index]["CityName"] = selectedOption.label;
    }
    try {
      // Validate specific field dynamically from schema
      await schema.validateAt(`${section}[${index}].${name}`, {
        [section]: updatedSection,
      });

      // Update form state and clear errors if valid
      setFormData((prevState) => ({
        ...prevState,
        [section]: updatedSection,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: "" },
        },
      }));
    } catch (err) {
      // Set validation error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: { ...prevErrors[section]?.[index], [name]: err.message },
        },
      }));
    }
  };

  const handleAddLine = (e, arrayName, defaultRowStructure, keyToCheck) => {
    e.preventDefault();

    // Employee History specific validation
    if (arrayName === "employeeDetails") {
      const lastIndex = formData?.employeeDetails?.length - 1;
      const lastRow = formData?.employeeDetails?.[lastIndex];
      const newRowIndex = lastIndex + 1;

      setSubDepartmentOptionsMap(prev => ({
        ...prev,
        [newRowIndex]: prev[lastIndex] || subDepartmentOptions || [],
      }));

      let hasError = false;
      let newErrors = { ...errors };

      // Check required fields
      if (
        !lastRow?.ShiftID ||
        !lastRow?.DepartmentID ||
        // !lastRow?.SubDepartmentID ||
        !lastRow?.DesignationID ||
        !lastRow?.FromDate
      ) {
        hasError = true;
      }

      // Check ToDate for employee history
      if (!lastRow?.ToDate) {
        if (!newErrors.employeeDetails) newErrors.employeeDetails = {};
        if (!newErrors.employeeDetails[lastIndex]) newErrors.employeeDetails[lastIndex] = {};
        newErrors.employeeDetails[lastIndex].ToDate = "To Date is required";
        hasError = true;
      }

      if (hasError) {
        setErrors(newErrors);
        toast.error("Please fill in the current row before adding a new one.");
        return;
      }
    }
    // Location History validation
    if (arrayName === 'empLocation' && formData[arrayName]?.length > 0) {
      const lastRow = formData[arrayName][formData[arrayName].length - 1];
      const requiredFields = ['CityID', 'FromDate', 'ToDate'];
      const isIncomplete = requiredFields.some(field =>
        !lastRow[field] || lastRow[field] === ""
      );

      if (isIncomplete) {
        toast.error("Please fill all fields in the current row before adding a new one");
        return;
      }
    }

    // Get the last row in the specified array
    const currentArray = formData[arrayName] || [];
    console.log("currentArray", currentArray);

    const currentRow = currentArray.length !== 0 ? currentArray[currentArray.length - 1] : null;

    // Find the smallest missing line number
    let newLineNo = currentArray.length > 0
      ? Math.max(...currentArray.map((row) => parseInt(row.LineNo) || 0)) + 1
      : 1;

    // Create a new row with dynamic structure
    const newRow = {
      LineNo: newLineNo.toString(),
      ID: "",
      isDelete: 1,
      canBeDisabled: 0,
      canBeTodateDisabled: 0,
      AccountNo: "",
      Bank: "",
      IFSCCode: "",
      Branch: "",
      DefaultBank: 0,
      IsComfirmedDocs:0,
      TargetDate: null,
      ...defaultRowStructure,
    };

    // For employee details, copy values from previous row
    if (arrayName === "employeeDetails" && currentRow) {
      newRow.ShiftID = currentRow?.ShiftID || "";
      newRow.DepartmentID = currentRow?.DepartmentID || "";
      newRow.SubDepartmentID = currentRow?.SubDepartmentID || "";
      newRow.DesignationID = currentRow?.DesignationID || "";
      newRow.FromDate = currentRow?.ToDate
        ? moment(currentRow.ToDate).add(1, "days").format("DD-MMM-YYYY")
        : null;
      newRow.ToDate = null;
      newRow.ImmediateSuperiorID = currentRow?.ImmediateSuperiorID || "";
      newRow.PracticeManager = currentRow?.PracticeManager || null;
      newRow.Branch = currentRow?.Branch || "";
    }

    // Ensure prevState[arrayName] is always an array
    setFormData((prevState) => ({
      ...prevState,
      [arrayName]: [...(prevState[arrayName] || []), newRow],
    }));
  };


  const deleteLine = (e, arrayName, lineNoToDelete) => {
    e.preventDefault();

    setFormData((prevState) => ({
      ...prevState,
      [arrayName]: prevState[arrayName].filter(
        (row) => row.LineNo !== lineNoToDelete
      ),
    }));
  };
  useEffect(() => {
    fetchIndexData();
  }, []);

// Runs once when existing rows load (e.g. edit mode)
useEffect(() => {
  if (formData?.employeeDetails?.length) {
    formData.employeeDetails.forEach((line, index) => {
      if (line.DepartmentID) {
        fetchSubDepartment(line.DepartmentID, index);
      }
    });
  }
}, []);

  const [titleOptions, setTitleOption] = useState([]);
  const [accountTypeOption, setAccounTypeOption] = useState([]);
  const [addressTypeOptions, setAddressTypeOptions] = useState([]);
  const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [conatctTypeOptions, setContactTYpeOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [subDepartmentOptions, setSubDepartmentOptions] = useState([]);
  const [subDepartmentOptionsMap, setSubDepartmentOptionsMap] = useState({});
  const [designationOptions, setDesignationOptions] = useState([]);
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [gstRegTypeOptions, setGstRegTypeOptions] = useState([]);
  const [identityIssueingOptions, setIdentityIssueingOptions] = useState([]);
  const [identityTypeOptions, setIdentityTypeOptions] = useState([]);
  const [immediateSuperiorOptions, setImmediateSuperiorOptions] = useState([]);
  const [leaveAcuralOptions, setLeaveAcrualTypeOptions] = useState([]);
  const [maritialStatusOptions, setMaritialStatusOptions] = useState([]);
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [referedByOptions, setReferedByOptions] = useState([]);
  const [relationTypeOptions, setRelationTypeOptions] = useState([]);
  const [brandTypeOptions, setBrandTypeOptions] = useState([]);
  const [subrandTypeOptions, setSubBrandTypeOptions] = useState([]);
  const [relievingTypeOptions, setRelievingTypeOptions] = useState([]);
  const [shiftsOptions, setShiftsOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [workingStatusOptions, setWorkingStatusOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);

  const fetchIndexData = async () => {
    try {
      let response = await GetServiceCaller(`${API_URL}rujul/employee-data`);
      if (response?.status === 200) {
        setPageLoading(false);
        // title option
        const titlesOpt = response?.data?.data?.titles?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setTitleOption(titlesOpt);

        const accTypeOpt = response?.data?.data?.account_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAccounTypeOption(accTypeOpt);
        const addressTypeOptions = response?.data?.data?.addressType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setAddressTypeOptions(addressTypeOptions);
        const bloodGrpOpt = response?.data?.data?.blood_group?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setBloodGroupOptions(bloodGrpOpt);
        const branchOpt = response?.data?.data?.branches?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setBranchOptions(branchOpt);
        const cityOpt = response?.data?.data?.cities?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCityOptions(cityOpt);
        const compOpt = response?.data?.data?.company?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCompanyOptions(compOpt);
        const contactTypeOpt = response?.data?.data?.contact_type?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setContactTYpeOptions(contactTypeOpt);
        const countryOpt = response?.data?.data?.country?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCountryOptions(countryOpt);
        const deptOpt = response?.data?.data?.department?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDepartmentOptions(deptOpt);
        const subDeptOpt = response?.data?.data?.sub_department?.map((option) => ({
          label: option.text,
          value: option.value,
        }))
        setSubDepartmentOptions(subDeptOpt);
        const desigOpt = response?.data?.data?.designation?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setDesignationOptions(desigOpt);
        const empOpt = response?.data?.data?.employee_type?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setEmployeeTypeOptions(empOpt);
        const genderOpt = response?.data?.data?.gender?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGenderOptions(genderOpt);
        const gstTypeOpt = response?.data?.data?.gstRegType?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setGstRegTypeOptions(gstTypeOpt);
        const identityIssueOpt =
          response?.data?.data?.identityIssueingCountry?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setIdentityIssueingOptions(identityIssueOpt);
        const identityTypeOpt = response?.data?.data?.identityType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setIdentityTypeOptions(identityTypeOpt);
        const immediateManagerOpt =
          response?.data?.data?.immediate_manager?.map((option) => ({
            label: option.text,
            value: option.value,
          }));
        setImmediateSuperiorOptions(immediateManagerOpt);
        const leaveAcrualTypeOpt = response?.data?.data?.leaveAcrualType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setLeaveAcrualTypeOptions(leaveAcrualTypeOpt);
        const maritialStatusOpt = response?.data?.data?.maritial_status?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setMaritialStatusOptions(maritialStatusOpt);
        const nationalityOpt = response?.data?.data?.nationality?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setNationalityOptions(nationalityOpt);
        const referOpt = response?.data?.data?.referredBy?.map((option) => ({
          label: option.TEXT,
          value: option.VALUE,
        }));
        setReferedByOptions(referOpt);
        const reletionTypeOpt = response?.data?.data?.relationType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelationTypeOptions(reletionTypeOpt);
        const relievingTypeOpt = response?.data?.data?.relievingType?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setRelievingTypeOptions(relievingTypeOpt);
         const brandTypeOpt = response?.data?.data?.brand?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setBrandTypeOptions(brandTypeOpt);
        const subrandTypeOptions = response?.data?.data?.subbrand?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setSubBrandTypeOptions(subrandTypeOptions);
        const shiftsOpt = response?.data?.data?.shifts?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setShiftsOptions(shiftsOpt);
        const stateOpt = response?.data?.data?.state?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setStateOptions(stateOpt);
        const workingStatOpt = response?.data?.data?.workingStatus?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setWorkingStatusOptions(workingStatOpt);
        const bankOpt = response?.data?.data?.bank?.map((option) => ({
          label: option.Name,
          value: option.ID,
        }));
        setBankOptions(bankOpt);
        const cityIdOpt = response?.data?.data?.city?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setCityIDOptions(cityIdOpt);

      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const fetchSubDepartment = async (deptId, rowIndex) => {
    try {
      if (!deptId) return;

      const res = await GetServiceCaller(`${API_URL}sub-department/${deptId}`);
      const data = res.data.data;

      const formattedOptions = data
        .filter(item => item.ID !== null && item.Name !== null)
        .map((item) => ({
          value: String(item.ID),
          label: item.Name,
        }));

      // Store options keyed by row index
      setSubDepartmentOptionsMap(prev => ({
        ...prev,
        [rowIndex]: formattedOptions,
      }));

    } catch (error) {
      console.error(error);
    }
  };

  // Safe getter — always returns an array, never undefined/null
  const getSubDeptOptions = (index) => {
    const mapped = subDepartmentOptionsMap[index];
    if (Array.isArray(mapped)) return mapped;
    if (Array.isArray(subDepartmentOptions)) return subDepartmentOptions;
    return [];
  };
  
  const rawStringToBlob = (rawString, contentType = "application/pdf") => {
    const byteNumbers = new Array(rawString.length);
    for (let i = 0; i < rawString.length; i++) {
      byteNumbers[i] = rawString.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  const handleBlobDownload = async (file) => {
    try {
      let blob;

      if (file.FileData) {
        // file.FileData is raw string (not base64)
        blob = rawStringToBlob(file.FileData, "application/pdf");
      } else if (file.filePath) {
        const response = await fetch(file.filePath);
        blob = await response.blob();
      } else {
        console.error("No file data or path available.");
        return;
      }

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.name || "downloaded_file.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("File download failed", error);
    }
  };




  const TooltipWrapper = ({ value, tooltipText, children }) => {
    const hasValue = value !== null && value !== undefined && value !== "";
    return hasValue ? (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{tooltipText}</Tooltip>}
      >
        <div>{children}</div>
      </OverlayTrigger>
    ) : (
      <div>{children}</div>
    );
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container Support-Padding">
          <form
            id="formOne"
            className="rounded mt-2 bg-white"
            onSubmit={handleSubmit}
          >
            <div className="container-fluid overflow-x-auto">
              <div className="d-flex justify-content-between align-items-center">
                <ul
                  className="nav nav-tabs flex flex-nowrap w-max space-x-2"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      style={{ color: "#2F2E4B" }}
                      id="general-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#general"
                      type="button"
                      role="tab"
                      aria-controls="general"
                      aria-selected="true"
                    >
                      General
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="personal-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#personal"
                      type="button"
                      role="tab"
                      aria-controls="personal"
                      aria-selected="false"
                    >
                      Contact
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="project-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#project"
                      type="button"
                      role="tab"
                      aria-controls="project"
                      aria-selected="false"
                    >
                      Bank
                    </button>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="rating-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#rating"
                  type="button"
                  role="tab"
                  aria-controls="rating"
                  aria-selected="false"
                >
                  Tax
                </button>
              </li> */}
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="other-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#other"
                      type="button"
                      role="tab"
                      aria-controls="other"
                      aria-selected="false"
                    >
                      HR
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="areas-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#areas"
                      type="button"
                      role="tab"
                      aria-controls="areas"
                      aria-selected="false"
                    >
                      Working Areas
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="locationhistory-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#locationhistory"
                      type="button"
                      role="tab"
                      aria-controls="locationhistory"
                      aria-selected="false"
                    >
                      Location History
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="attachment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#attachment"
                      type="button"
                      role="tab"
                      aria-controls="attachment"
                      aria-selected="false"
                    >
                      Attachments
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="qualification-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#qualification"
                      type="button"
                      role="tab"
                      aria-controls="qualification"
                      aria-selected="false"
                    >
                      Qualification
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="identities-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#identities"
                      type="button"
                      role="tab"
                      aria-controls="identities"
                      aria-selected="false"
                    >
                       Identities
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="employmentdetails-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#employmentdetails"
                      type="button"
                      role="tab"
                      aria-controls="employmentdetails"
                      aria-selected="false"
                    >
                      Employment Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="additional-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#additional"
                      type="button"
                      role="tab"
                      aria-controls="additional"
                      aria-selected="false"
                    >
                      Additional
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="missingdocs-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#employeedocs"
                      type="button"
                      role="tab"
                      aria-controls="employeedocs"
                      aria-selected="false"
                    >
                      Missing Docs
                    </button>
                  </li>
                </ul>

                {/* Right side button */}
                <div className="ms-3">
                  <button
                    className="custom-btn"
                    onClick={() => {
                      navigate(`/employee-list/EmployeePayrolls/edit/${id}`);
                    }}
                  >
                    Payroll
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-content" id="myTabContent">
              {/* General Details */}
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-md-10">
                      <div className="row">
                        <div className="col-md-2">
                          <label className="form-label">Code</label>
                          <input
                            type="text"
                            placeholder="Code"
                            className="form-control"
                            id="EmpCode"
                            name="EmpCode"
                            value={formData?.EmpCode}
                            disabled
                          />
                        </div>
                        <div className="col-md-2">
                          <label className="form-label">
                            Title <span className="required">*</span>
                          </label>
                          <Select
                            name="Title"
                            options={[
                              { value: "", label: "Select" },
                              ...titleOptions,
                            ]}
                            className={` ${errors.Salutation_019 ? "is-invalid" : ""
                              }`}
                            value={titleOptions.find(
                              (option) => option.value === formData?.Title
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                          {errors.Salutation_019 && (
                            <div className="error">{errors.Salutation_019}</div>
                          )}
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="FirstName" className="form-label">
                              First Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="First Name"
                              className="form-control"
                              id="FirstName"
                              name="FirstName"
                              value={formData?.FirstName}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.FirstName && (
                              <div className="error">{errors.FirstName}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="MiddleName" className="form-label">
                              Middle Name
                            </label>
                            <input
                              type="text"
                              placeholder="Middle Name"
                              className="form-control"
                              id="MiddleName"
                              name="MiddleName"
                              value={formData?.MiddleName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="LastName" className="form-label">
                              Last Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              className="form-control"
                              id="LastName"
                              name="LastName"
                              value={formData?.LastName}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.LastName && (
                              <div className="error">{errors.LastName}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="FatherName" className="form-label">
                              Father Name
                            </label>
                            <input
                              type="text"
                              placeholder="Father's Name"
                              className="form-control"
                              id="FatherName"
                              name="FatherName"
                              value={formData?.FatherName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="FatherDOB" className="form-label">
                              Father's DOB
                            </label>
                            <CustomDatePicker
                              name="FatherDOB"
                              id="FatherDOB"
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              value={formData?.FatherDOB || null}
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="MotherName" className="form-label">
                              Mother Name
                            </label>
                            <input
                              type="text"
                              placeholder="Mother's Name"
                              className="form-control"
                              id="MotherName"
                              name="MotherName"
                              value={formData?.MotherName}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="MotherDOB" className="form-label">
                              Mother's DOB
                            </label>
                            <CustomDatePicker
                              name="MotherDOB"
                              id="MotherDOB"
                              value={formData?.MotherDOB}
                              placeholderText="DD-MMM-YYYY"
                              className="form-control"
                              handleChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-2">
                          <div className="">
                            <label className="form-label">
                              Contact Type <span className="required">*</span>
                            </label>
                            <Select
                              name="ContactType_011"
                              options={[
                                { value: "", label: "Select" },
                                ...conatctTypeOptions,
                              ]}
                              className={` ${errors.ContactType_011 ? "is-invalid" : ""
                                }`}
                              value={conatctTypeOptions.find(
                                (option) =>
                                  option.value === formData?.ContactType_011
                              )}
                              // value={formData?.ContactType}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />

                            {errors.ContactType_011 && (
                              <div className="error">
                                {errors.ContactType_011}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="">
                            <label className="form-label">
                              Account <span className="required">*</span>
                            </label>
                            <Select
                              name="AccountType"
                              options={[
                                { value: "", label: "Select" },
                                ...accountTypeOption,
                              ]}
                              // value={formData?.AccountType}
                              value={accountTypeOption.find(
                                (option) =>
                                  option.value === formData?.AccountType
                              )}
                              className={` ${errors.AccountType ? "is-invalid" : ""
                                }`}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                            {errors.AccountType && (
                              <div className="error">{errors.AccountType}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-sm-2">
                          <div className="">
                            <label className="form-label">
                              Gender <span className="required">*</span>
                            </label>
                            <Select
                              name="Gender_020"
                              // value={formData?.Gender_020}
                              value={genderOptions.find(
                                (option) =>
                                  option.value === formData?.Gender_020
                              )}
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              className={` ${errors.Gender_020 ? "is-invalid" : ""
                                }`}
                              options={[
                                { value: "", label: "Select" },
                                ...genderOptions,
                              ]}
                            />
                            {errors.Gender_020 && (
                              <div className="error">{errors.Gender_020}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">
                            Date Of Birth<span className="required">*</span>
                          </label>
                          <CustomDatePicker
                            name="DateOfBirth"
                            id="DateOfBirth"
                            placeholderText="DD-MMM-YYYY"
                            value={formData?.DateOfBirth}
                            handleChange={(e) => handleChange(e)}
                            required={true}
                            className={`form-control ${errors?.DateOfBirth ? "is-invalid" : ""
                              }`}
                          />
                          {errors.DateOfBirth && (
                            <span class="error">{errors?.DateOfBirth}</span>
                          )}
                        </div>
                        <div className="col-sm-2">
                          <label htmlFor="IsInActive" className="form-label">
                            Active
                          </label>
                          <div className="me-2 mt-0">
                            <div className="d-flex">
                              <div className="form-check me-2" key={"Yes"}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="IsInActive"
                                  id="rating_1_yes"
                                  value={1}
                                  checked={formData?.IsInActive === 1}
                                  onChange={handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="rating_1_yes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check me-2" key={"No"}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="IsInActive"
                                  id="rating_1_No"
                                  value={0}
                                  checked={formData?.IsInActive === 0}
                                  onChange={handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="rating_1_No"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-2 text-center mt-4">
                      <ProfileInput
                        handleProfilePic={handleProfilePic}
                        image={formData?.UploadProfileImg}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Details */}
              <div
                className="tab-pane fade show"
                id="personal"
                role="tabpanel"
                aria-labelledby="personal-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Mobile No. 1 <span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          name="MobileNo1"
                          placeholder="Mobile No. 1"
                          className="form-control"
                          value={formData?.MobileNo1}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.MobileNo1 && (
                          <div className="error">{errors.MobileNo1}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">Mobile No. 2</label>
                        <input
                          type="number"
                          name="MobileNo2"
                          placeholder="Desk Phone No."
                          className="form-control"
                          value={formData?.MobileNo2}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.MobileNo2 && (
                          <div className="error">{errors.MobileNo2}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">WhatsApp No.</label>
                        <input
                          type="number"
                          name="DeskPhoneNo"
                          placeholder="WhatsApp No."
                          value={formData?.DeskPhoneNo}
                          onChange={(e) => handleChange(e)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Emergency Phone No.<span className="required">*</span>
                        </label>

                        <input
                          type="number"
                          placeholder="Emergency Contact No."
                          className="form-control"
                          name="EmergencyPhoneNo"
                          value={formData?.EmergencyPhoneNo}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyPhoneNo && (
                          <div className="error">{errors.EmergencyPhoneNo}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Emergency Contact Name
                          <span className="required">*</span>
                        </label>
                        <input
                          placeholder="Emergency Contact Name"
                          className="form-control"
                          type="text"
                          name="EmergencyContactName"
                          value={formData?.EmergencyContactName}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyContactName && (
                          <div className="error">
                            {errors.EmergencyContactName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Contact Relation<span className="required">*</span>
                        </label>
                        <input
                          placeholder="Emergency Contact Relation"
                          className="form-control"
                          type="text"
                          name="EmergencyContactRelation"
                          value={formData?.EmergencyContactRelation}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.EmergencyContactRelation && (
                          <div className="error">
                            {errors.EmergencyContactRelation}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          Personal Email<span className="required">*</span>
                        </label>
                        <input
                          placeholder="Personal Email"
                          className="form-control"
                          type="text"
                          name="PersonalEmail"
                          value={formData?.PersonalEmail}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.PersonalEmail && (
                          <div className="error">{errors.PersonalEmail}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">
                          NSS Email <span className="required">*</span>
                        </label>
                        <input
                          placeholder="Official Email"
                          className="form-control"
                          type="text"
                          name="OfficeEmail"
                          value={formData?.OfficeEmail}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.OfficeEmail && (
                          <div className="error">{errors.OfficeEmail}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="form-label">Joining Location <span className="required">*</span></label>
                        <input
                          placeholder="Location"
                          className="form-control"
                          type="text"
                          name="Location"
                          value={formData?.Location}
                          onChange={(e) => handleChange(e)}
                        />
                         {errors.Location && (
                          <div className="error">{errors.Location}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <div className="mt-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="IsRemotly"
                              id="IsRemotly"
                              checked={formData?.IsRemotly === "1"}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="IsRemotly"
                            >
                              Is Working Remotely?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Correspondence Address Section */}
                    <div className="col-sm-6">
                      <p>
                        <strong>Correspondence Address</strong>
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="">
                            <label className="form-label">Address Type</label>
                            <Select
                              isDisabled={true}
                              name="CorrepondenceAddressType"
                              options={[
                                { value: "", label: "Select" },
                                ...addressTypeOptions,
                              ]}
                              value={addressTypeOptions.find(
                                (option) =>
                                  option.value ===
                                  formData?.CorrepondenceAddressType
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">
                              Address<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="CorrespondenceAddress"
                              placeholder="Address"
                              value={formData?.CorrespondenceAddress}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            Country<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            name="CorrespondenceCountry"
                            options={[
                              { value: "", label: "Select" },
                              ...countryOptions,
                            ]}
                            // value={formData.Country}
                            value={countryOptions.find(
                              (option) =>
                                option.value === formData?.CorrespondenceCountry
                            ) || null}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">
                            State<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            name="CorrespondenceState"
                            options={[
                              { value: "", label: "Select" },
                              ...stateOptions,
                            ]}
                            value={stateOptions.find(
                              (option) =>
                                option.value === formData?.CorrespondenceState
                            ) || null}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            City<span className="required">*</span>
                          </label>
                          <Select
                            name="CorrespondenceCity"
                            options={[
                              { value: "", label: "Select" },
                              ...cityOptions,
                            ]}
                            value={cityOptions.find(
                              (option) =>
                                option.value === formData?.CorrespondenceCity
                            ) || null}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                          {/* {errors?.CorrespondenceCity?.status && (
                                                               <span className="error">
                                                                   {errors?.CorrespondenceCity?.message}
                                                               </span>
                                                           )} */}
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">Zip Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="CorrespondenceZipCode"
                              placeholder="Zipcode"
                              value={formData?.CorrespondenceZipCode}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label">Print Address</label>
                            <input
                              className="form-control"
                              type="text"
                              name="CorrespondenceAddressPrint"
                              value={formData?.CorrespondenceAddressPrint}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Permanent Address Section */}
                    <div className="col-sm-6">
                      <p className="d-flex gap-1">
                        <strong>Permanent Address</strong>(
                        <div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="IsCopyAddress"
                              value="1"
                              id="IsCopyAddress"
                              checked={formData?.IsCopyAddress == 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;

                                // Validation: Check if correspondence address and city are provided
                                if (
                                  isChecked &&
                                  (!formData?.CorrespondenceAddress ||
                                    !formData?.CorrespondenceCity)
                                ) {
                                  toast.error(
                                    "Please enter First Correspondence Address"
                                  );
                                  return;
                                }

                                handleChange(e);

                                if (isChecked) {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 1, // Ensure checkbox state updates
                                    permanentAddressCode:
                                      prevData.CorrespondenceAddress || "",
                                    permanentAddressCountryID:
                                      prevData.CorrespondenceCountry || "",
                                    permanentAddressStateID:
                                      prevData.CorrespondenceState || "",
                                    permanentAddressCityID:
                                      prevData.CorrespondenceCity || "",
                                    permanentAddressZipCode:
                                      prevData.CorrespondenceZipCode || "",
                                    permanentPrintAddress:
                                      prevData.CorrespondenceAddressPrint || "",
                                  }));
                                } else {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    IsCopyAddress: 0,
                                    permanentAddressCode: "",
                                    permanentAddressCountryID: "",
                                    permanentAddressStateID: "",
                                    permanentAddressCityID: "",
                                    permanentAddressZipCode: "",
                                    permanentPrintAddress: "",
                                  }));
                                }
                              }}
                            />

                            <label class="form-check-label" for="IsCopyAddress">
                              Is Same as Correspondence Address?)
                            </label>
                          </div>
                        </div>
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="">
                            <label className="form-label">Address Type</label>
                            <Select
                              isDisabled={true}
                              name="PermanentAddressType"
                              options={[
                                { value: "", label: "Select" },
                                ...addressTypeOptions,
                              ]}
                              value={addressTypeOptions.find(
                                (option) =>
                                  option.value ===
                                  formData?.PermanentAddressType
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">
                              Address <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              name="permanentAddressCode"
                              value={formData?.permanentAddressCode}
                              className="form-control"
                              onChange={(e) => handleChange(e)}
                              placeholder="Address"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            Country<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            name="permanentAddressCountryID"
                            options={[
                              { value: "", label: "Select" },
                              ...countryOptions,
                            ]}
                            // value={formData.Country}
                            value={countryOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressCountryID
                            )}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">
                            State<span className="required">*</span>
                          </label>
                          <Select
                            type="text"
                            options={[
                              { value: "", label: "Select" },
                              ...stateOptions,
                            ]}
                            value={stateOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressStateID
                            )}
                            name="permanentAddressStateID"
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">
                            City<span className="required">*</span>
                          </label>
                          <Select
                            name="permanentAddressCityID"
                            options={[
                              { value: "", label: "Select" },
                              ...cityOptions,
                            ]}
                            value={cityOptions.find(
                              (option) =>
                                option.value ===
                                formData?.permanentAddressCityID
                            )}
                            onChange={(selectedOption, action) => {
                              handleSelect(selectedOption, action.name);
                            }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="form-label">Zip Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="permanentAddressZipCode"
                              value={formData?.permanentAddressZipCode}
                              onChange={(e) => handleChange(e)}
                              placeholder="Zipcode"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label">Print Address</label>
                            <input
                              className="form-control"
                              type="text"
                              name="permanentPrintAddress"
                              onChange={(e) => handleChange(e)}
                              value={formData?.permanentPrintAddress}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bank Details */}
              <div
                className="tab-pane fade show"
                id="project"
                role="tabpanel"
                aria-labelledby="project-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employeebank",
                                initialFormData?.employeebank,
                                "PayTo"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <Table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "15%" }}>Pay To</th>
                                <th style={{ width: "15%" }}>
                                  Bank<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>Branch</th>
                                <th style={{ width: "15%" }}>
                                  Account No.<span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  IFSC Code<span className="required">*</span>
                                </th>
                                <th
                                  style={{
                                    width: "5%",
                                    textAlign: "center",
                                  }}
                                >
                                  Default
                                </th>
                                <th style={{ width: "5%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employeebank &&
                                formData.employeebank.map &&
                                formData.employeebank.map((line, index) => (
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="In case of contractor"
                                        className="form-control"
                                        name="PayTo"
                                        value={`${formData.FirstName || ""} ${formData.LastName || ""
                                          }`.trim()}
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Select
                                        menuPlacement="top"
                                        styles={tableSelectStyle}
                                        menuPortalTarget={document.body}
                                        name="Bank"
                                        value={bankOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeebank[index].Bank
                                        )}
                                        options={[
                                          { value: "", label: "Select" },
                                          ...bankOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="Branch"
                                        className="form-control"
                                        name="Branch"
                                        value={
                                          formData.employeebank?.[index].Branch
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        placeholder="Account No"
                                        className={"form-control text-end"}
                                        name="AccountNo"
                                        value={
                                          formData.employeebank[index].AccountNo
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            ["e", "E", "+", "-", "."].includes(
                                              e.key
                                            )
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      {/* {errors?.employeebank?.[index]
                                                                            ?.AccountNo?.status && (
                                                                                <span class="error">
                                                                                    {
                                                                                        errors?.employeebank?.[index]
                                                                                            ?.AccountNo?.message
                                                                                    }
                                                                                </span>
                                                                            )} */}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        placeholder="IFSC Code"
                                        className={"form-control"}
                                        name="IFSCCode"
                                        value={
                                          formData.employeebank[index].IFSCCode
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      ></input>
                                      {/* {errors?.employeebank?.[index]
                                                                            ?.IFSCCode?.status && (
                                                                                <span class="error">
                                                                                    {
                                                                                        errors?.employeebank?.[index]
                                                                                            ?.IFSCCode?.message
                                                                                    }
                                                                                </span>
                                                                            )} */}
                                    </td>
                                    <td className="text-center align-middle">
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value="1"
                                        name="DefaultBank"
                                        id="DefaultBank"
                                        checked={
                                          formData.employeebank[index]
                                            .DefaultBank === 1
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeebank"
                                          )
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={
                                          line.isDelete
                                            ? (e) =>
                                              deleteLine(
                                                e,
                                                "employeebank",
                                                line.LineNo
                                              )
                                            : undefined
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete
                                            ? "auto"
                                            : "none",
                                          cursor: line.isDelete
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>
                                    {/* <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                            handleChangeWithIndex(
                                                e,
                                                "remove",
                                                "employeebank",
                                                index,
                                                ""
                                            )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td> */}
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tax Detail */}
              {/* <div
                className="tab-pane fade show"
                id="rating"
                role="tabpanel"
                aria-labelledby="rating-tab"
              >
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-2 form-group">
                      <label className="form-label">GSTNo/UIN</label>
                      <input
                        type="text"
                        name="GSTNo"
                        value={formData.GSTNo}
                        placeholder="GSTNo"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">VAT/TIN</label>
                      <input
                        type="text"
                        name="VATNo"
                        value={formData?.VATNo}
                        className="form-control"
                        placeholder="VATNo"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">CST No.</label>
                      <input
                        type="text"
                        name="CSTNo"
                        value={formData?.CSTNo}
                        className="form-control"
                        placeholder="CST No."
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">PAN No.</label>
                      <input
                        type="text"
                        name="PANNo"
                        value={formData.PANNo}
                        placeholder="PAN No."
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">GST Date</label>
                      <CustomDatePicker
                        name="GSTEffectiveDate"
                        id="GSTEffectiveDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.GSTEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">VAT Date</label>
                      <CustomDatePicker
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.VATEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">CST Date</label>
                      <CustomDatePicker
                        name="CSTEffectiveDate"
                        id="CSTEffectiveDate"
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                        value={formData?.CSTEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2 form-group">
                      <label className="form-label">Service Tax No.</label>
                      <input
                        type="text"
                        name="STNo"
                        id="STNo"
                        className="form-control"
                        placeholder="Service Tax No."
                        value={formData?.STNo}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">GST Reg. Type</label>
                      <Select
                        options={[
                          { value: "", label: "Select" },
                          ...gstRegTypeOptions,
                        ]}
                        name="GSTRegistrationType_192"
                        value={gstRegTypeOptions.find(
                          (option) =>
                            option.value === formData?.GSTRegistrationType_192
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Service Tax Date</label>
                      <CustomDatePicker
                        name="STEffectiveDate"
                        id="STEffectiveDate"
                        placeholderText="DD-MMM-YYYY"
                        className="form-control"
                        value={formData?.STEffectiveDate}
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              {/* HR Details */}
              <div
                className="tab-pane fade show"
                id="other"
                role="tabpanel"
                aria-labelledby="other-tab"
              >
                <div className="container-fluid mt-2">
                  {/* Employee History Section - OPTIMIZED WITH 85% VISUAL SCALE */}
                  <div
                    className="tab-pane fade show"
                    id="other"
                    role="tabpanel"
                    aria-labelledby="other-tab"
                  >
                    {/* Localized styles targeting ONLY this specific tab container */}
                    <style>{`
                      .scaled-history-container {
                        transform: scale(0.85);
                        transform-origin: top left;
                        width: 117.6%; /* Offsets the scale shrink to fill the horizontal canvas width completely */
                        margin-bottom: -50px; /* Pulls up following whitespace caused by scaling matrix */
                      }
                      .laptop-compact-table th {
                        font-size: 12px !important;
                        padding: 6px 4px !important;
                        white-space: nowrap;
                        font-weight: 600 !important;
                        vertical-align: middle;
                      }
                      .laptop-compact-table td {
                        padding: 4px 2px !important;
                        vertical-align: middle !important;
                      }
                      .laptop-compact-table .react-select-container {
                        font-size: 12px !important;
                      }
                      .laptop-compact-table .form-control {
                        font-size: 12px !important;
                        padding: 0.25rem 0.4rem !important;
                      }
                    `}</style>

                    <div className="container-fluid mt-2 scaled-history-container">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-2">
                              <label className="form-label">Working Status</label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...workingStatusOptions,
                                ]}
                                value={workingStatusOptions.find(
                                  (option) => option.value === formData?.WorkingStatus
                                )}
                                name="WorkingStatus"
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label">
                                Leave Accrual Type
                              </label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...leaveAcuralOptions,
                                ]}
                                value={leaveAcuralOptions.find(
                                  (option) => option.value === formData?.LeaveAccrualType_155
                                )}
                                name="LeaveAccrualType_155"
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            <div className="col-sm-2">
                              <label className="form-label">Referred By</label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...referedByOptions,
                                ]}
                                value={referedByOptions.find(
                                  (option) => option.value === formData?.ReferBy
                                )}
                                name="ReferBy"
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            <div className="col-sm-2">
                              <div className="form-group">
                                <label className="form-label">
                                  Resignation Date
                                </label>
                                <CustomDatePicker
                                  name="ResignationDate"
                                  id="ResignationDate"
                                  placeholderText="DD-MMM-YYYY"
                                  className="form-control"
                                  value={formData?.ResignationDate}
                                  handleChange={(e) => handleChange(e)}
                                />
                              </div>
                            </div>
                            <div className="col-sm-2">
                              <div className="form-group">
                                <label className="form-label">
                                  Resg. Acceptance Date
                                </label>
                                <CustomDatePicker
                                  name="ConfirmationDate"
                                  id="ConfirmationDate"
                                  placeholderText="DD-MMM-YYYY"
                                  className="form-control"
                                  value={formData.ConfirmationDate}
                                  handleChange={(e) => handleChange(e)}
                                />
                              </div>
                            </div>
                            <div className="col-sm-2">
                              <div className="form-group">
                                <label className="form-label">Relieving Date</label>
                                <CustomDatePicker
                                  name="RelivingDate"
                                  id="RelivingDate"
                                  placeholderText="DD-MMM-YYYY"
                                  className="form-control"
                                  value={formData?.RelivingDate}
                                  handleChange={(e) => handleChange(e)}
                                />
                              </div>
                            </div>
                            <div className="col-sm-2 mt-2">
                              <label className="form-label">Relieving Type</label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...relievingTypeOptions,
                                ]}
                                name="RelivingType_119"
                                value={relievingTypeOptions.find(
                                  (option) =>
                                    option.value === formData?.RelivingType_119
                                )}
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            <div className="col-sm-2 mt-2">
                              <label className="form-label">Band<span className="required">*</span></label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...brandTypeOptions,
                                ]}
                                name="BandType_2015"
                                value={brandTypeOptions.find(
                                  (option) =>
                                    option.value === formData?.BandType_2015
                                )}
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                              {errors.BandType_2015 && (
                                <div className="error">{errors.BandType_2015}</div>
                              )}
                            </div>
                            <div className="col-sm-2 mt-2">
                              <label className="form-label">Sub Band<span className="required">*</span></label>
                              <Select
                                options={[
                                  { value: "", label: "Select" },
                                  ...subrandTypeOptions,
                                ]}
                                name="SubBandType_2015"
                                value={
                                  subrandTypeOptions.find(
                                    (option) =>
                                      String(option.value) === String(formData?.SubBandType_2015)
                                  ) || null
                                }
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                              {errors.SubBandType_2015 && (
                                <div className="error">{errors.SubBandType_2015}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Employee History Grid Layout with Reduced Padding Scales */}
                      <div className="row mt-4">
                        <div className="col-sm-12">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <strong style={{ fontSize: "15px", color: "#2F2E4B" }}>Employee History Details</strong>
                            <button
                              type="button"
                              className="custom-btn"
                              onClick={(e) =>
                                handleAddLine(
                                  e,
                                  "employeeDetails",
                                  initialFormData?.employeeDetails,
                                  "branch"
                                )
                              }
                            >
                              Add New Record
                            </button>
                          </div>
                          
                          <div className="table-responsive poc-head rounded border">
                            <Table className="table table-bordered laptop-compact-table" style={{ marginBottom: 0 }}>
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "11%" }}>Branch*</th>
                                  <th style={{ width: "11%" }}>Shift*</th>
                                  <th style={{ width: "11%" }}>Department*</th>
                                  <th style={{ width: "11%" }}>Sub Department</th>
                                  <th style={{ width: "12%" }}>Designation*</th>
                                  <th style={{ width: "12%" }}>Immediate Supervisor*</th>
                                  <th style={{ width: "12%" }}>Practice Manager*</th>
                                  <th style={{ width: "10%" }}>From Date*</th>
                                  <th style={{ width: "10%" }}>To Date</th>
                                  <th style={{ width: "5%" }}>Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.employeeDetails &&
                                  formData.employeeDetails.map &&
                                  formData.employeeDetails.map((line, index) => (
                                    <tr key={index}>
                                      {/* Branch */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.Branch}
                                          tooltipText={
                                            branchOptions.find(opt => opt.value === line.Branch)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            name="Branch"
                                            value={branchOptions.find(opt => opt.value == line.Branch)}
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...branchOptions]}
                                            isDisabled={line.canBeDisabled === 1}
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "Branch", index, "employeeDetails")
                                            }
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.Branch && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].Branch}</div>
                                        )}
                                      </td>

                                      {/* Shift */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.ShiftID}
                                          tooltipText={
                                            shiftsOptions.find(opt => opt.value === line.ShiftID)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            name="ShiftID"
                                            value={shiftsOptions.find(opt => opt.value === line.ShiftID)}
                                            isDisabled={line.canBeDisabled === 1}
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...shiftsOptions]}
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "ShiftID", index, "employeeDetails")
                                            }
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.ShiftID && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].ShiftID}</div>
                                        )}
                                      </td>

                                      {/* Department */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.DepartmentID}
                                          tooltipText={
                                            departmentOptions.find(opt => opt.value === line.DepartmentID)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            name="DepartmentID"
                                            isDisabled={line.canBeDisabled === 1}
                                            value={departmentOptions.find(opt => opt.value === line.DepartmentID)}
                                            onChange={(selectedOption) => {
                                              handleLineSelect(selectedOption, "DepartmentID", index, "employeeDetails");

                                              if (selectedOption?.value) {
                                                fetchSubDepartment(selectedOption.value, index); // ✅ pass index
                                              } else {
                                                // Clear sub-dept options for this row if dept is cleared
                                                setSubDepartmentOptionsMap(prev => ({
                                                  ...prev,
                                                  [index]: [],
                                                }));
                                              }
                                            }}
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...departmentOptions]}
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.DepartmentID && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].DepartmentID}</div>
                                        )}
                                      </td>

                                      {/* Sub Department */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.SubDepartmentID}
                                          tooltipText={
                                            getSubDeptOptions(index).find(
                                              opt => String(opt.value) === String(line.SubDepartmentID)
                                            )?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            name="SubDepartmentID"
                                            isDisabled={line.canBeDisabled === 1}
                                            value={
                                              getSubDeptOptions(index).find(
                                                opt => String(opt.value) === String(line.SubDepartmentID)
                                              ) || null
                                            }
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "SubDepartmentID", index, "employeeDetails")
                                            }
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...getSubDeptOptions(index)]}
                                          />
                                        </TooltipWrapper>
                                      </td>

                                      {/* Designation */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.DesignationID}
                                          tooltipText={
                                            designationOptions.find(opt => opt.value === line.DesignationID)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            name="DesignationID"
                                            isDisabled={
                                              formData?.FirstName?.toLowerCase().includes("sub_contractor")
                                                ? false
                                                : line.canBeDisabled === 1
                                            }
                                            value={designationOptions.find(opt => opt.value === line.DesignationID)}
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...designationOptions]}
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "DesignationID", index, "employeeDetails")
                                            }
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.DesignationID && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].DesignationID}</div>
                                        )}
                                      </td>

                                      {/* Immediate Supervisor */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.ImmediateSuperiorID}
                                          tooltipText={
                                            immediateSuperiorOptions.find(opt => opt.value === line.ImmediateSuperiorID)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            isDisabled={line.canBeDisabled === 1}
                                            name="ImmediateSuperiorID"
                                            value={immediateSuperiorOptions.find(opt => opt.value === line.ImmediateSuperiorID)}
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "ImmediateSuperiorID", index, "employeeDetails")
                                            }
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...immediateSuperiorOptions]}
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.ImmediateSuperiorID && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].ImmediateSuperiorID}</div>
                                        )}
                                      </td>

                                      {/* Practice Manager */}
                                      <td>
                                        <TooltipWrapper
                                          value={line.PracticeManager}
                                          tooltipText={
                                            immediateSuperiorOptions.find(opt => opt.value === line.PracticeManager)?.label
                                          }
                                        >
                                          <Select
                                            classNamePrefix="react-select"
                                            isDisabled={formData.employeeDetails?.length - 1 == index ? false : line.canBeDisabled === 1}
                                            name="PracticeManager"
                                            value={immediateSuperiorOptions.find(opt => opt.value === line.PracticeManager) || null}
                                            onChange={(selectedOption) =>
                                              handleLineSelect(selectedOption, "PracticeManager", index, "employeeDetails")
                                            }
                                            menuPortalTarget={document.body}
                                            styles={tableSelectStyle}
                                            menuPlacement="auto"
                                            options={[{ value: "", label: "Select" }, ...immediateSuperiorOptions]}
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.PracticeManager && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].PracticeManager}</div>
                                        )}
                                      </td>

                                      {/* From Date */}
                                      <td>
                                        <TooltipWrapper value={line.FromDate} tooltipText={line.FromDate}>
                                          <CustomDatePicker
                                            required
                                            readOnly={line.canBeDisabled === 1}
                                            handleChange={(e) => handleAllLineChange(e, index, "employeeDetails")}
                                            minDate={(() => {
                                              const prevToDate = formData.employeeDetails[index - 1]?.ToDate;
                                              return prevToDate && moment(prevToDate).isValid()
                                                ? moment(prevToDate).add(1, "days").toDate()
                                                : new Date();
                                            })()}
                                            name="FromDate"
                                            value={line.FromDate}
                                            className={errors?.employeeDetails?.[index]?.FromDate ? "is-invalid form-control" : "form-control"}
                                            portalId="datepicker-portal"
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.FromDate && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].FromDate}</div>
                                        )}
                                      </td>

                                      {/* To Date */}
                                      <td>
                                        <TooltipWrapper value={line.ToDate} tooltipText={line.ToDate}>
                                          <CustomDatePicker
                                            portalId="root-portal"
                                            readOnly={line.canBeTodateDisabled === 1}
                                            handleChange={(e) => handleAllLineChange(e, index, "employeeDetails")}
                                            minDate={moment().subtract(1, "months").endOf("month").toDate()}
                                            name="ToDate"
                                            value={line.ToDate}
                                            className={errors?.employeeDetails?.[index]?.ToDate ? "is-invalid form-control" : "form-control"}
                                          />
                                        </TooltipWrapper>
                                        {errors?.employeeDetails?.[index]?.ToDate && (
                                          <div className="text-danger small px-1">{errors.employeeDetails[index].ToDate}</div>
                                        )}
                                      </td>

                                      {/* Delete Action Row */}
                                      <td className="text-center align-middle">
                                        <a
                                          href="#!"
                                          onClick={
                                            line.isDelete
                                              ? (e) => deleteLine(e, "employeeDetails", line.LineNo)
                                              : (e) => e.preventDefault()
                                          }
                                          className={line.isDelete ? "text-danger" : "text-muted"}
                                          style={{
                                            pointerEvents: line.isDelete ? "auto" : "none",
                                            cursor: line.isDelete ? "pointer" : "not-allowed",
                                          }}
                                        >
                                          <i className={`bi bi-trash icons ${line.isDelete ? "" : "disabled-icon"}`}></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Working Areas */}
              <div
                className="tab-pane fade show"
                id="areas"
                role="tabpanel"
                aria-labelledby="areas-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "workingarea",
                                initialFormData?.workingarea,
                                "EmployeeType_069"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <Table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "32%" }}>
                                  Employee Type
                                  {/* <span className="required">*</span> */}
                                </th>
                                <th style={{ width: "32%" }}>
                                  Branch
                                  {/* <span className="required">*</span> */}
                                </th>
                                <th style={{ width: "32%" }}>Company</th>
                                <th style={{ width: "4%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.workingarea &&
                                formData.workingarea.map &&
                                formData.workingarea.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        name="EmployeeType_069"
                                        value={employeeTypeOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index]
                                              .EmployeeType_069
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...employeeTypeOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                      />
                                      {errors[
                                        `workingarea[${index}].EmployeeType_069`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `workingarea[${index}].EmployeeType_069`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.workingarea?.[index]
                                          //     ?.EmployeeType_069?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="Branch"
                                        // value={formData.workingarea[index].branch}
                                        value={branchOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index].Branch
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...branchOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                      />
                                      {errors[
                                        `workingarea[${index}].Branch`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `workingarea[${index}].Branch`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.workingarea?.[index]
                                          //     ?.EmployeeType_069?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="Company"
                                        // value={
                                        //     formData.workingarea[index]
                                        //         .company
                                        // }
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "workingarea"
                                          )
                                        }
                                        value={companyOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.workingarea[index].Company
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...companyOptions,
                                        ]}
                                      />
                                      {/* {errors?.workingarea?.[index]
                                                                            ?.company?.status && (
                                                                                <span className="error">
                                                                                    {" "}
                                                                                    {
                                                                                        errors?.workingarea?.[index]
                                                                                            ?.company?.message
                                                                                    }
                                                                                </span>
                                                                            )} */}
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={
                                          line.isDelete
                                            ? (e) =>
                                              deleteLine(
                                                e,
                                                "workingarea",
                                                line.LineNo
                                              )
                                            : undefined
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete
                                            ? "auto"
                                            : "none",
                                          cursor: line.isDelete
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>
                                    {/* <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                            handleChangeWithIndex(
                                                e,
                                                "remove",
                                                "workingarea",
                                                index,
                                                ""
                                            )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td> */}
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Location History */}
              <div
                className="tab-pane fade show"
                id="locationhistory"
                role="tabpanel"
                aria-labelledby="locationhistory-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "empLocation",
                                initialFormData?.empLocation,
                                "CityID"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "30%" }}>
                                  City
                                </th>
                                <th style={{ width: "30%" }}>From Date</th>
                                <th style={{ width: "30%" }}>To Date</th>
                                <th style={{ width: "10%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.empLocation &&
                                formData.empLocation.map &&
                                formData.empLocation.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        name="CityID"
                                        value={cityIDOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.empLocation[index].CityID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="bottom"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...cityIDOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                        // index={index}
                                        module="empLocation"
                                        name="FromDate"
                                        value={
                                          formData.empLocation[index].FromDate
                                        }
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "empLocation"
                                          )
                                        }
                                        // index={index}
                                        module="empLocation"
                                        name="ToDate"
                                        value={
                                          formData.empLocation[index].ToDate
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                          deleteLine(
                                            e,
                                            "empLocation",
                                            line.LineNo
                                          )
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete
                                            ? "auto"
                                            : "none",
                                          cursor: line.isDelete
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employee Attachment */}
              <div
                className="tab-pane fade show"
                id="attachment"
                role="tabpanel"
                aria-labelledby="attachment-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <span className="pull-right">
                            {" "}
                            Max 5 MB | Allowed: PDF, JPG, PNG &nbsp;
                            <FileUploader handleFile={handleFile} />
                          </span>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "50%" }}>File Name</th>
                                <th style={{ width: "30%" }}>File Size</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData?.files?.map((file, index) => (
                                <tr key={index}>
                                  <td>
                                    {file.FileData ? (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleBlobDownload(file)}
                                      >
                                        Download {file.name}
                                      </button>
                                    ) : (
                                      <a
                                        href={
                                          file.filePath
                                            ? file.filePath
                                            : URL.createObjectURL(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {file.name}
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {formData.filesize?.[index]}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="attach_msg">
                          Note:
                          <ul>
                            <li>
                              Please attach all relevant supporting documents.
                            </li>
                            <li>
                              File Naming Format: YourName_FileName.extension (e.g., JohnDoe_Resume.pdf, JohnDoe_10thMarkSheet.pdf).
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* qualification */}
              <div
                className="tab-pane fade show"
                id="qualification"
                role="tabpanel"
                aria-labelledby="qualification-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "qualification",
                                initialFormData?.qualification,
                                "QualificationType"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "15%" }}>
                                  Qualification Type
                                  <span className="text-danger">*</span>
                                </th>
                                <th style={{ width: "10%" }}>Qualification</th>
                                <th style={{ width: "10%" }}>Stream</th>
                                <th style={{ width: "20%" }}>Institute</th>
                                <th style={{ width: "12%" }}>Percentage / CGPA</th>
                                <th style={{ width: "15%" }}>
                                  Year Of Passing
                                </th>
                                <th style={{ width: "13%" }}>University</th>
                                <th style={{ width: "8%" }}>File</th>
                                <th style={{ width: "10%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.qualification &&
                                formData.qualification.map &&
                                formData.qualification.map((line, index) => (
                                  <tr>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Qualification Type"
                                        name="QualificationType"
                                        value={
                                          formData.qualification[index]
                                            .QualificationType
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                      {errors[
                                        `qualification[${index}].QualificationType`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `qualification[${index}].QualificationType`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={"form-control"}
                                        placeholder="Qualification"
                                        name="Qualification"
                                        value={
                                          formData.qualification[index]
                                            .Qualification
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                      {errors[
                                        `qualification[${index}].Qualification`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `qualification[${index}].Qualification`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Stream"
                                        name="Stream"
                                        value={
                                          formData.qualification[index].Stream
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Institute"
                                        name="Institute"
                                        value={
                                          formData.qualification[index]
                                            .Institute
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className="form-control text-end"
                                        placeholder="%"
                                        name="Percentage"
                                        value={
                                          formData.qualification[index]
                                            .Percentage
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            ["e", "E", "+", "-", "."].includes(
                                              e.key
                                            )
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control text-end"
                                        placeholder="Year Of Passing"
                                        name="YearOfPassing"
                                        value={
                                          formData.qualification[index]
                                            .YearOfPassing
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className={
                                          // errors?.qualification?.[index]
                                          //   ?.University?.status
                                          //   ? "is-invalid form-control"
                                          //   :
                                          "form-control"
                                        }
                                        placeholder="University"
                                        name="University"
                                        value={
                                          formData.qualification[index]
                                            .University
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "qualification"
                                          )
                                        }
                                      />
                                      {/* {errors?.qualification?.[index]
                                              ?.University?.status && (
                                              <span className="error">
                                                {
                                                  errors?.qualification?.[index]
                                                    ?.University?.message
                                                }
                                              </span>
                                            )} */}
                                    </td>
                                    <td className="text-center align-middle">
                                      {(line?.QualificationFile || line?.FilePath || line?.FileName) && (
                                        <a
                                          href={
                                            line?.QualificationFile ||
                                            line?.FilePath ||
                                            (line?.FileName ? `/storage/uploads/candidate-in-lineup/documents/${line.FileName}` : "#")
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title="View File"
                                        >
                                          <i
                                            className="fa fa-eye"
                                            style={{
                                              fontSize: "16px",
                                              color: "#27568B",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </a>
                                      )}
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={
                                          line.isDelete
                                            ? (e) =>
                                              deleteLine(
                                                e,
                                                "qualification",
                                                line.LineNo
                                              )
                                            : undefined
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete
                                            ? "auto"
                                            : "none",
                                          cursor: line.isDelete
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>
                                    {/* <td className="text-center align-middle">
                                      <a
                                          onClick={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "remove",
                                              "qualification",
                                              index,
                                              ""
                                            )
                                          }
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td> */}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employee identities */}
              <div
                className="tab-pane fade show"
                id="identities"
                role="tabpanel"
                aria-labelledby="identities-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "identities",
                                initialFormData?.identities,
                                "IdentityType_063"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                             <tr>
                                <th style={{ width: "13%" }}>
                                  Identity Type
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "18%" }}>
                                  Name On Identity
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "14%" }}>
                                  Identity No.
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "13%" }}>
                                  Issuing Country
                                  <span className="required">*</span>
                                </th>
                                <th style={{ width: "13%" }}>Issue Date</th>
                                <th style={{ width: "13%" }}>Expiry Date</th>
                                <th style={{ width: "6%" }}>File</th>
                                <th style={{ width: "6%" }}>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.identities &&
                                formData.identities.map &&
                                formData.identities.map((line, index) => (
                                  <tr>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.identities?.[index]?.Type
                                          //     ?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="IdentityType_063"
                                        value={identityTypeOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.identities[index]
                                              .IdentityType_063
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...identityTypeOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IdentityType_063`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IdentityType_063`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={
                                          // errors?.identities?.[index]?.NameOnIdentity
                                          //     ?.status
                                          //     ? "is-invalid form-control"
                                          //     :
                                          "form-control"
                                        }
                                        placeholder="Name as per identity"
                                        name="NameOnIdentity"
                                        value={
                                          formData.identities[index]
                                            .NameOnIdentity
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].NameOnIdentity`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].NameOnIdentity`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        className={
                                          // errors?.identities?.[index]
                                          //     ?.Number?.status
                                          //     ? "is-invalid form-control"
                                          //     :
                                          "form-control"
                                        }
                                        placeholder="No"
                                        name="IdentityNo"
                                        value={
                                          formData.identities[index].IdentityNo
                                        }
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IdentityNo`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IdentityNo`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Select
                                        className={
                                          // errors?.identities?.[index]
                                          //     ?.Country?.status
                                          //     ? "is-invalid"
                                          //     :
                                          ""
                                        }
                                        name="IssuingCountry"
                                        value={identityIssueingOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.identities[index]
                                              .IssuingCountry
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...identityIssueingOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "identities"
                                          )
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IssuingCountry`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IssuingCountry`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        // index={index}
                                        module="identities"
                                        name="IssueDate"
                                        value={
                                          formData.identities[index].IssueDate
                                        }
                                      />
                                      {errors[
                                        `identities[${index}].IssueDate`
                                      ] && (
                                          <span className="error">
                                            {
                                              errors[
                                              `identities[${index}].IssueDate`
                                              ]
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "identities"
                                          )
                                        }
                                        // index={index}
                                        module="identities"
                                        name="ExpiryDate"
                                        value={
                                          formData.identities[index].ExpiryDate
                                        }
                                      />
                                    </td>
                                     {/* for file view  */}
                                    <td className="text-center align-middle">
                                        {(formData.identities[index]?.IdentityFile || line?.IdentityFile || line?.FileName || line?.FilePath) && (
                                          <a
                                            href={
                                              typeof (formData.identities[index]?.IdentityFile || line?.IdentityFile || line?.FileName || line?.FilePath) === "string"
                                                ? (formData.identities[index]?.IdentityFile || line?.IdentityFile || line?.FileName || line?.FilePath)
                                                : formData.identities[index]?.IdentityFilePreview
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="View File"
                                          >
                                            <i
                                              className="fa fa-eye"
                                              style={{
                                                fontSize: "16px",
                                                color: "#27568B",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </a>
                                        )}
                                    </td>
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={
                                          line.isDelete
                                            ? (e) =>
                                              deleteLine(
                                                e,
                                                "identities",
                                                line.LineNo
                                              )
                                            : undefined
                                        }
                                        className={
                                          line.isDelete
                                            ? "text-danger"
                                            : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete
                                            ? "auto"
                                            : "none",
                                          cursor: line.isDelete
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                            }`}
                                        ></i>
                                      </a>
                                    </td>

                                    {/* <td className="text-center align-middle">
                                      <a
                                        onClick={(e) =>
                                            handleChangeWithIndex(
                                                e,
                                                "remove",
                                                "identities",
                                                index,
                                                ""
                                            )
                                        }
                                        className=""
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    </td> */}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employment Details */}
              <div
                className="tab-pane fade show"
                id="employmentdetails"
                role="tabpanel"
                aria-labelledby="employmentdetails-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employment_history",
                                initialFormData?.employment_history,
                                "OrganizationName"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>
                        <div className="table-responsive poc-head rounded">
                          <table
                            id="poctable_head"
                            className="table table-bordered"
                          >
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "18%" }}>Organization Name</th>
                                <th style={{ width: "15%" }}>Location</th>
                                <th style={{ width: "12%" }}>Start Date</th>
                                <th style={{ width: "12%" }}>End Date</th>
                                <th style={{ width: "15%" }}>Position</th>
                                <th style={{ width: "8%" }}>Offer Letter</th>
                                <th style={{ width: "8%" }}>Salary Slip</th>
                                <th style={{ width: "8%" }}>Relieving & Exp.</th>
                                <th style={{ width: "4%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.employment_history &&
                                formData.employment_history.map &&
                                formData.employment_history.map((line, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Organization Name"
                                        name="OrganizationName"
                                        value={formData.employment_history[index]?.OrganizationName || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Location"
                                        name="Location"
                                        value={formData.employment_history[index]?.Location || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                        module="employment_history"
                                        name="StartDate"
                                        value={formData.employment_history[index]?.StartDate || ""}
                                      />
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        required={true}
                                        handleChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                        module="employment_history"
                                        name="EndDate"
                                        value={formData.employment_history[index]?.EndDate || ""}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        placeholder="Position"
                                        name="Position"
                                        value={formData.employment_history[index]?.Position || ""}
                                        onChange={(e) =>
                                          handleAllLineChange(e, index, "employment_history")
                                        }
                                      />
                                    </td>
                                    {/* View Offer Letter */}
                                    <td className="text-center align-middle">
                                      {formData.employment_history[index]?.OfferLetter && (
                                        <a
                                          href={
                                            typeof formData.employment_history[index].OfferLetter === "string"
                                              ? formData.employment_history[index].OfferLetter
                                              : formData.employment_history[index].OfferLetterPreview
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title="View Offer Letter"
                                        >
                                          <i className="fa fa-eye" style={{ fontSize: "16px", color: "#27568B", cursor: "pointer" }} />
                                        </a>
                                      )}
                                    </td>
                                    {/* View Salary Slip */}
                                    <td className="text-center align-middle">
                                      {formData.employment_history[index]?.SalarySlip && (
                                        <a
                                          href={
                                            typeof formData.employment_history[index].SalarySlip === "string"
                                              ? formData.employment_history[index].SalarySlip
                                              : formData.employment_history[index].SalarySlipPreview
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title="View Salary Slip"
                                        >
                                          <i className="fa fa-eye" style={{ fontSize: "16px", color: "#27568B", cursor: "pointer" }} />
                                        </a>
                                      )}
                                    </td>
                                    {/* View Relieving Letter */}
                                    <td className="text-center align-middle">
                                      {formData.employment_history[index]?.RelievingLetter && (
                                        <a
                                          href={
                                            typeof formData.employment_history[index].RelievingLetter === "string"
                                              ? formData.employment_history[index].RelievingLetter
                                              : formData.employment_history[index].RelievingLetterPreview
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title="View Relieving & Exp. Letter"
                                        >
                                          <i className="fa fa-eye" style={{ fontSize: "16px", color: "#27568B", cursor: "pointer" }} />
                                        </a>
                                      )}
                                    </td>
                                    {/* Action Delete */}
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={(e) => deleteLine(e, "employment_history", index)}
                                        className="text-danger"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="bi bi-trash icons"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Additional identities */}
              <div
                className="tab-pane fade show"
                id="additional"
                role="tabpanel"
                aria-labelledby="additional-tab"
              >
                <div className="container-fluid mt-3">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Blood Group<span className="text-danger">*</span></label>
                        <Select
                          name="BloodGroup_062"
                          options={[
                            { value: "", label: "Select" },
                            ...bloodGroupOptions,
                          ]}
                          // value={formData?.BloodGroup_062}
                          value={bloodGroupOptions.find(
                            (option) =>
                              option.value === formData?.BloodGroup_062
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Marital Status</label>
                        <Select
                          name="MaritalStatus_021"
                          options={[
                            { value: "", label: "Select" },
                            ...maritialStatusOptions,
                          ]}
                          // value={formData?.MaritalStatus_021}
                          value={maritialStatusOptions.find(
                            (option) =>
                              option.value === formData?.MaritalStatus_021
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Nationality</label>
                      <Select
                        options={[
                          { value: "", label: "Select" },
                          ...nationalityOptions,
                        ]}
                        // value={formData.Nationality}
                        name="Nationality"
                        value={nationalityOptions.find(
                          (option) => option.value === formData?.Nationality
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Anniversary Date</label>
                        <CustomDatePicker
                          name="DateOfAnniversary"
                          id="DateOfAnniversary"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.DateOfAnniversary}
                          handleChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Appointment Date <span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="AppointmentDate"
                          id="AppointmentDate"
                          placeholderText="DD-MMM-YYYY"
                          value={formData?.AppointmentDate}
                          handleChange={(e) => handleChange(e)}
                          required={true}
                          className={`form-control ${errors?.AppointmentDate ? "is-invalid" : ""
                            }`}
                        />
                        {errors.AppointmentDate && (
                          <span class="error">{errors?.AppointmentDate}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Payroll Joining Date
                          <span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="PayrollJoiningDate"
                          id="PayrollJoiningDate"
                          placeholderText="DD-MMM-YYYY"
                          // readOnly={true}
                          readOnly={joiningDateDisable}
                          className="form-control"
                          value={formData?.PayrollJoiningDate}
                          handleChange={(e) => handleChange(e)}
                        />
                        {errors.PayrollJoiningDate && (
                          <span class="error">
                            {errors?.PayrollJoiningDate}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Joining Date<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          name="JoiningDate"
                          id="JoiningDate"
                          placeholderText="DD-MMM-YYYY"
                          value={formData?.JoiningDate}
                          readOnly={true}
                          handleChange={(e) => handleChange(e)}
                          maxDate={false}
                          required={true}
                          minDate={new Date(formData?.AppointmentDate)}
                          className={`form-control ${errors?.JoiningDate ? "is-invalid" : ""
                            }`}
                        />
                        {errors.JoiningDate && (
                          <span class="error">{errors?.JoiningDate}</span>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">
                          Branch<span className="required">*</span>
                        </label>
                        <Select
                          options={[
                            { value: "", label: "Select" },
                            ...branchOptions,
                          ]}
                          name="BranchID"
                          value={branchOptions.find(
                            (option) => option.value === formData?.BranchID
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                        {/* {errors?.Branch?.status && (
                                                <span class="error">
                                                    {errors?.Branch?.message}
                                                </span>
                                            )} */}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Total Exp.(In Yrs.)<span className="required">*</span></label>
                        <input
                          type="text"
                          name="TotalYearExp"
                          className="form-control text-end"
                          value={formData?.TotalYearExp}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.TotalYearExp && (
                          <span class="error">{errors?.TotalYearExp}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Total Exp.(In Mos.)<span className="required">*</span></label>
                        <input
                          type="text"
                          name="TotalMonthExp"
                          className="form-control text-end"
                          value={formData?.TotalMonthExp}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.TotalMonthExp && (
                          <span class="error">{errors?.TotalMonthExp}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">PF Nominee Name<span className="text-danger">*</span></label>
                        <input
                          placeholder="PF Nominee Name"
                          className="form-control"
                          type="text"
                          name="PFNomineeName"
                          value={formData?.PFNomineeName || ""}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">PF Nominee Relation<span className="text-danger">*</span></label>
                        <input
                          placeholder="PF Nominee Relation"
                          className="form-control"
                          type="text"
                          name="PFNomineeRelation"
                          value={formData?.PFNomineeRelation || ""}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                     {formData?.MaritalStatus_021 === 140 && (
                                          <>
                                            <div className="col-sm-2">
                                              <div>
                                                <label className="form-label">Spouse Name</label>
                                                <input
                                                  placeholder="Spouse Name"
                                                  className="form-control"
                                                  type="text"
                                                  name="SpouseName"
                                                  value={formData?.SpouseName}
                                                  onChange={(e) => handleChange(e)}
                                                />
                                              </div>
                                            </div>
                    
                                            <div className="col-sm-2">
                                              <div>
                                                <label className="form-label">Spouse D.O.B</label>
                                                <CustomDatePicker
                                                  name="SpouseDOB"
                                                  id="SpouseDOB"
                                                  placeholderText="DD-MMM-YYYY"
                                                  className="form-control"
                                                  value={formData?.SpouseDOB}
                                                  handleChange={(e) => handleChange(e)}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        )}
                     <div className="row mt-3">
                                      {formData?.MaritalStatus_021 === 140 && (
                                          <>
                                         <div className="col-sm-2">
                                          <div className="">
                                            <label className="form-label">Child 1 Name</label>
                                            <input
                                              placeholder="Child 1 Name"
                                              className="form-control"
                                              type="text"
                                              name="Child1Name"
                                              value={formData?.Child1Name}
                                              onChange={(e) => handleChange(e)}
                                            />
                                            {/* {errors.BranchID && (
                                              <span class="error">{errors?.BranchID}</span>
                                            )} */}
                                          </div>
                                        </div>
                                         <div className="col-sm-2">
                                          <div className="">
                                            <label className="form-label">Child 1 D.O.B</label>
                                            <CustomDatePicker
                                              name="Child1DOB"
                                              id="Child1DOB"
                                              placeholderText="DD-MMM-YYYY"
                                              readOnly={formData?.MaritalStatus_021 !== 140}
                                              className="form-control"
                                              value={formData?.Child1DOB}
                                              handleChange={(e) => handleChange(e)}
                                            />
                                          </div>
                                        </div>
                                         <div className="col-sm-2">
                                          <div className="">
                                            <label className="form-label">Child 2  Name</label>
                                            <input
                                              placeholder="Child 2 Name"
                                              className="form-control "
                                              type="text"
                                              name="Child2Name"
                                              value={formData?.Child2Name}
                                              onChange={(e) => handleChange(e)}
                                            />
                                            {/* {errors.BranchID && (
                                              <span class="error">{errors?.BranchID}</span>
                                            )} */}
                                          </div>
                                        </div>
                                         <div className="col-sm-2">
                                          <div className="">
                                            <label className="form-label">Child 2 D.O.B</label>
                                            <CustomDatePicker
                                              name="Child2DOB"
                                              id="Child2DOB"
                                              placeholderText="DD-MMM-YYYY"
                                              readOnly={formData?.MaritalStatus_021 !== 140}
                                              className="form-control"
                                              value={formData?.Child2DOB}
                                              handleChange={(e) => handleChange(e)}
                                            />
                                          </div>
                                        </div>
                                        <div className="mt-3"></div>
                                        </>
                                        )}
                                     <div className="d-flex flex-wrap align-items-center gap-5">
                                        <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="OnPayroll"
                                                  checked={formData?.OnPayroll === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">OnPayroll</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="IsIntern"
                                                  checked={formData?.IsIntern === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Apprenticeship</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="IsPartTime"
                                                  checked={formData?.IsPartTime === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">PartTime</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="Bond"
                                                  checked={formData?.Bond === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Bond</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="Incentives"
                                                  checked={formData?.Incentives === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Incentives</label>
                                              </div>

                                              <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  name="JoiningBonus"
                                                  checked={formData?.JoiningBonus === "1"}
                                                  onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label">Joining Bonus</label>
                                              </div>
                                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Employee Missing Documents */}
              <div
                className="tab-pane fade show"
                id="employeedocs"
                role="tabpanel"
                aria-labelledby="missingdocs-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <p>
                          <button
                            className="custom-btn pull-right"
                            onClick={(e) =>
                              handleAddLine(
                                e,
                                "employeedocs",
                                initialFormData?.employeedocs,
                                "IdentityType_063"
                              )
                            }
                          >
                            Add New Record
                          </button>
                        </p>

                        <div className="table-responsive poc-head rounded">
                          <table id="missingdocs_table" className="table table-bordered">
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th style={{ width: "25%" }}>
                                  Document Type <span className="required">*</span>
                                </th>
                                <th style={{ width: "60%" }}>
                                  Remarks <span className="required">*</span>
                                </th>
                                <th style={{ width: "15%" }}>
                                  Target Date <span className="required">*</span>
                                </th>
                                <th style={{ width: "10%" }}>
                                  Is Submitted
                                </th>
                                <th style={{ width: "5%" }}>Delete</th>
                              </tr>
                            </thead>

                            <tbody>
                              {formData.employeedocs &&
                                formData.employeedocs.map &&
                                formData.employeedocs.map((line, index) => (
                                  <tr key={index}>
                                    {/* Document Type */}
                                    <td>
                                      <Select
                                        name="IdentityType_063"
                                        value={identityTypeOptions.find(
                                          (option) =>
                                            option.value ===
                                            formData.employeedocs[index].IdentityType_063
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={tableSelectStyle}
                                        menuPlacement="top"
                                        options={[
                                          { value: "", label: "Select" },
                                          ...identityTypeOptions,
                                        ]}
                                        onChange={(selectedOption, action) =>
                                          handleLineSelect(
                                            selectedOption,
                                            action.name,
                                            index,
                                            "employeedocs"
                                          )
                                        }
                                        className={
                                          errors?.employeedocs?.[index]?.IdentityType_063 
                                            ? "is-invalid" 
                                            : ""
                                        }
                                      />
                                      {errors?.employeedocs?.[index]?.IdentityType_063 && (
                                        <span className="error">
                                          {errors.employeedocs[index].IdentityType_063}
                                        </span>
                                      )}
                                    </td>
                                    
                                    {/* Document Remark */}
                                    <td>
                                      <input
                                        className={`form-control ${
                                          errors?.employeedocs?.[index]?.Remarks 
                                            ? "is-invalid" 
                                            : ""
                                        }`}
                                        placeholder="Enter Document Missing Remark"
                                        name="Remarks"
                                        value={formData.employeedocs[index].Remarks}
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeedocs"
                                          )
                                        }
                                      />
                                      {errors?.employeedocs?.[index]?.Remarks && (
                                        <span className="error">
                                          {errors.employeedocs[index].Remarks}
                                        </span>
                                      )}
                                    </td>
                                    {/* Target Date - NEW FIELD */}
                                    <td>
                                      <CustomDatePicker
                                        name="TargetDate"
                                        placeholderText="DD-MMM-YYYY"
                                        value={formData.employeedocs[index].TargetDate}
                                        handleChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeedocs"
                                          )
                                        }
                                        className="form-control"
                                      />
                                    </td>
                                    {/* Is Submitted */}
                                    <td className="text-center align-middle">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="1"
                                        name="IsComfirmedDocs"
                                        id="IsComfirmedDocs"
                                        checked={
                                          formData.employeedocs[index].IsComfirmedDocs === 1
                                        }
                                        disabled={
                                          // formData.employeedocs[index].IsComfirmedDocs === 1 && 
                                          // (formData.employeedocs[index].ContactID || formData.employeedocs[index].LineNo)
                                          formData.employeedocs[index].canBeDisabled === 1
                                        }
                                        
                                        onChange={(e) =>
                                          handleAllLineChange(
                                            e,
                                            index,
                                            "employeedocs"
                                          )
                                        }
                                      />
                                    </td>
                                    
                                    {/* Delete */}
                                    <td className="text-center align-middle">
                                      <a
                                        onClick={
                                          line.isDelete
                                            ? (e) =>
                                                deleteLine(e, "employeedocs", line.LineNo)
                                            : undefined
                                        }
                                        className={
                                          line.isDelete ? "text-danger" : "text-muted"
                                        }
                                        style={{
                                          pointerEvents: line.isDelete ? "auto" : "none",
                                          cursor: line.isDelete ? "pointer" : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`bi bi-trash icons${
                                            line.isDelete ? "" : " disabled-icon"
                                          }`}
                                        ></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid d-flex justify-content-end mt-5">
              <div>
                <button
                  type="reset"
                  onClick={() => navigate("/employee-list")}
                  className="cancel-btn me-2"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className={`custom-btn ${submitted ? "submitting" : ""}`}
                  disabled={submitted}
                  aria-disabled={submitted}
                  aria-busy={submitted}
                  style={{
                    cursor: submitted ? "not-allowed" : "pointer",
                    opacity: submitted ? 0.7 : 1,
                  }}
                >
                  {submitted ? (
                    <>
                      <FaSpinner
                        className="sm-spinner spin"
                        aria-hidden="true"
                      />
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default EmployeeEdit;
